<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left">
      </div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons"/>
      </div>
      <div class="align-right">
        <headerbuttonstack :state="sideButtons" />
      </div>
    </div>
    <div class="scrollbar-container content">
      <div class="full">
        <div class="mainheader">
          {{ $t('employee.import.importJobs') }}
        </div>
        <div class="header-right" style="margin-right: 32px;">
          <div v-if="importJob.id == null" class="prevent-select">
            <div class="icon-button" v-on:click="currentPage = 1;"><i class="fas fa-angles-left"/></div>
            <div class="icon-button" v-on:click="currentPage = currentPage <= 1 ? 1 : currentPage - 1;"><i class="fas fa-angle-left"/></div>
            <div class="label-pagination">{{ formattedCurrentPage }} / {{ pages }}</div>
            <div class="icon-button" style="margin-left: 10px;" v-on:click="currentPage = currentPage >= pages ? pages : currentPage + 1;"><i class="fas fa-angle-right"/></div>
            <div class="icon-button" style="margin-left: 10px;" v-on:click="currentPage = pages;"><i class="fas fa-angles-right"/></div>
          </div>
        </div>
      </div>


      <div v-if="loading">
        <i class="fas fa-circle-notch fa-spin"></i> {{ ' ' + $t('employee.collective.pleaseWait') }}<br/>
        <div
          style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
        ></div>
      </div>


      <div v-show="!loading && importJob.id == null">
        <table class="styled-table">
          <thead>
          <tr>
            <th scope="col">{{ $t('settings.sync.startedBy') }}</th>
            <th scope="col">{{ $t('employee.import.jobStarted') }}</th>
            <th scope="col">{{ $t('employee.import.jobEnded') }}</th>
            <th scope="col">{{ $t('employee.import.method') }}</th>
            <th class="center" scope="col">{{ $t('employee.import.candidates') }}</th>
            <th class="center" scope="col">{{ $t('employee.import.actionRequired') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="job in paginatedFilteredJobs" :key="'employeeImportRow_'+job.id" style="line-height: 36px">
            <td style="width: 20%">{{ job.authuserName ? job.authuserName : "System" }}</td>
            <td style="width: 20%">{{ job.jobStartedConverted }}</td>
            <td style="width: 20%">{{ job.jobEndedConverted }}</td>
            <td style="width: 10%">{{ job.method.toUpperCase() }}</td>
            <td class="center" style="width: 10%">
              <button v-tooltip="$t('employee.import.showAllCandidates')" type="button" class="icon-button" style="margin-left: 1%" v-on:click="loadAndOpenCandidates(job)">
                <i class="fas fa-magnifying-glass" />
              </button>
            </td>
            <td class="center" style="width: 20%" v-if="job.actionRequired">
              <button v-tooltip="$t('employee.contract.showDetails')" type="button" class="icon-button" style="margin-left: 1%"
                      v-on:click="selectImportJob(job)"><i class="fas fa-info-circle" /></button>
            </td>
            <td class="center" style="width: 20%" v-if="!job.actionRequired">-</td>
          </tr>
          </tbody>
        </table>
      </div>


      <div v-show="!loading && importJob.id != null">

        <table class="styled-table">
          <thead>
            <tr>
              <th scope="col">{{ $t('employee.import.internalId') }}</th>
              <th scope="col">{{ $t('employee.import.externalId') }}</th>
              <th scope="col">{{ $t('employee.core.firstName') }}</th>
              <th scope="col">{{ $t('employee.core.lastName') }}</th>
              <th scope="col">{{ $t('employee.core.birthdate') }}</th>
              <th scope="col">{{ $t('employee.export.socialInsuranceNumber') }}</th>
              <th scope="col"></th>
              <th scope="col">{{ $t('global.ui.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="candidate in inspectedCandidates">
              <tr v-if="candidate.actionRequired" :key="'employeeImportCandidateRow_'+candidate.id" style="line-height: 36px"
                  v-bind:style="{'background-color' : (candidate.id == employeeCandidateDiffId) ? '#bbb' : 'var(--bg)'}">
                <td>{{ candidate.remoteId }}</td>
                <td>{{ candidate.externalId }}</td>
                <td>{{ candidate.firstName }}</td>
                <td>{{ candidate.lastName }}</td>
                <td>{{ candidate.dob }}</td>
                <td>{{ candidate.socialsecurity }}</td>
                <td>
                  <i v-tooltip="$t('employee.import.showCandidate')"
                    v-on:click="openSingleCandidatesModal(candidate)" class="fas fa-magnifying-glass"></i>
                </td>
                <td>
                  <button type="button" class="btn btn-sm btn-ml" style="margin-left: 1%"
                          v-on:click="checkCandidateAction(candidate)">{{ $t('employee.import.check') }}</button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>


    <b-modal size="xl" ref="modal-all-candidates" @close="closeAllCandidatesModal()" centered>
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">{{ $t('employee.import.candidateDetailsPlural') }}</div>
        </div>
      </template>
      <b-container fluid>
        <div class="full">
          <table class="styled-table" style="width: 100%">
            <tr>
              <th scope="col">{{ $t('employee.import.internalId') }}</th>
              <th scope="col">{{ $t('employee.import.externalId') }}</th>
              <th scope="col">{{ $t('employee.core.firstName') }}</th>
              <th scope="col">{{ $t('employee.core.lastName') }}</th>
              <th scope="col">{{ $t('employee.core.birthdate') }}</th>
              <th scope="col">{{ $t('employee.export.socialInsuranceNumber') }}</th>
              <th scope="col"></th>
            </tr>
            <tr v-for="candidate in inspectedCandidates" :key="'employeeImportCandidatePopupRow_'+candidate.id" style="line-height: 36px">
              <td>{{ candidate.remoteId }}</td>
              <td>{{ candidate.externalId }}</td>
              <td>{{ candidate.firstName }}</td>
              <td>{{ candidate.lastName }}</td>
              <td>{{ candidate.dob }}</td>
              <td>{{ candidate.socialsecurity }}</td>
              <td>
                <i v-tooltip="$t('employee.import.showCandidate')"
                    v-on:click="openSingleCandidatesModal(candidate)" class="fas fa-magnifying-glass"></i>
                &nbsp;
                <i v-if="candidate.actionRequired" class="fas fa-triangle-exclamation" style="color: var(--ml)" />
              </td>
            </tr>
          </table>
        </div>
      </b-container>
      <template slot="modal-footer">
        <div class="button right" @click="closeAllCandidatesModal()">
          <div class="label">{{ $t('global.ui.close') }}</div>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" ref="modal-single-candidate" @close="closeSingleCandidatesModal()" centered>
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">
            {{ $t('employee.import.candidateDetails') }}
            <i v-if="inspectedCandidate.actionRequired" class="fas fa-triangle-exclamation" />
          </div>
        </div>
      </template>
      <b-container fluid>
        <div class="full">
          <table style="width: 100%">
              <tr>
                  <th>{{ $t('employee.import.importStartedBy') }}</th>
                  <td>
                      {{
                          inspectedCandidatesJob && inspectedCandidatesJob.authuserName != null
                              ? inspectedCandidatesJob.authuserName
                              : $t('employee.import.unknown')
                      }}
                  </td>
              </tr>
              <tr v-if="candidateActions[inspectedCandidate.id] !== undefined">
                  <th>{{ $t('employee.import.candidateActionPerformedBy') }}</th>
                  <td>
                      {{
                          candidateActions[inspectedCandidate.id].authuserName != null
                              ? candidateActions[inspectedCandidate.id].authuserName
                              : $t('employee.import.unknown')
                      }}
                  </td>
              </tr>
              <tr v-if="candidateActions[inspectedCandidate.id] !== undefined">
                  <th>{{ $t('employee.import.action') }}:</th>
                  <td v-if="candidateActions[inspectedCandidate.id].actionTaken === 'skip'">
                      {{ $t('employee.import.actionSkip') }}
                  </td>
                  <td v-if="candidateActions[inspectedCandidate.id].actionTaken === 'createEmployee'">
                      {{ $t('employee.import.actionCreateEmployee') }}
                  </td>
                  <td v-if="candidateActions[inspectedCandidate.id].actionTaken === 'matchEmployee'">
                      {{ $t('employee.import.actionMatchEmployee') }}
                  </td>
                  <td v-if="candidateActions[inspectedCandidate.id].actionTaken === 'forceEmployeeUpdate'">
                      {{ $t('employee.import.actionForceUpdate') }}
                  </td>
                  <td v-if="candidateActions[inspectedCandidate.id].actionTaken === 'updateEmployeeWithoutCoreData'">
                      {{ $t('employee.import.actionUpdateWithoutCore') }}
                  </td>
              </tr>
              <tr v-if="candidateActions[inspectedCandidate.id] !== undefined">
                  <th>{{ $t('employee.import.actionExecutedAt') }}</th>
                  <td>
                      {{
                          candidateActions[inspectedCandidate.id].actionTakenAtConverted != null
                              ? candidateActions[inspectedCandidate.id].actionTakenAtConverted
                              : "&nbsp;"
                      }}
                  </td>
              </tr>
              <tr><td>&nbsp;</td></tr>
            <tr>
              <th>ID</th>
              <td>{{ inspectedCandidate.id != null ? inspectedCandidate.id : "&nbsp;"}}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('internalEmployeeNotFound') ? { color:'red' } : {}">{{ $t('employee.data.internalId') }}</th>
              <td>{{ inspectedCandidate.remoteId != null ? inspectedCandidate.remoteId : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired &&
              (isActionRequiredReason('internalEmployeeNotFound') || isActionRequiredReason('externalDataChanged','externalId'))
              ? { color:'red' } : {}">{{ $t('employee.import.externalId') }}</th>
              <td>{{ inspectedCandidate.externalId != null ? inspectedCandidate.externalId : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.import.companyId') }}</th>
              <td>{{ inspectedCandidate.companyId != null ? inspectedCandidate.companyId + " (" + companyData.name + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && (!inspectedCandidate.storeId || isActionRequiredReason('externalDataChanged', ['storeId', 'stid']))
              ? { color:'red' } : {}">Store ID</th>
              <td>{{ inspectedCandidate.storeId != null ?
                    (storeArray.find(s => s.id === parseInt(inspectedCandidate.storeId)) ?
                      inspectedCandidate.storeId + " (" + storeArray.find(s => s.id === parseInt(inspectedCandidate.storeId)).name + ")"
                      : inspectedCandidate.storeId)
                    : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['costCenterId', 'ccntid'])
              ? { color:'red' } : {}">{{ $t('comp.ui.costCenter')}} ID</th>
              <td>{{ inspectedCandidate.costCenterId != null ?
                      (costCenterArray.find(c => c.id === parseInt(inspectedCandidate.costCenterId)) ?
                        inspectedCandidate.costCenterId + " (" + costCenterArray.find(c => c.id === parseInt(inspectedCandidate.costCenterId)).name + ")"
                        : inspectedCandidate.costCenterId)
                    : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>MD ID</th>
              <td>{{ inspectedCandidate.mdid != null ? inspectedCandidate.mdid : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>Account ID</th>
              <td>{{ inspectedCandidate.accountId != null ? inspectedCandidate.accountId : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('global.ui.pNumber') }}</th>
              <td>{{ inspectedCandidate.personnelId != null ? inspectedCandidate.personnelId : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('global.ui.taxId') }}</th>
              <td>{{ inspectedCandidate.taxId != null ? inspectedCandidate.taxId : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="(inspectedCandidate.actionRequired
                && (isActionRequiredReason('missingdata', 'firstName')
                  || isActionRequiredReason('coreDataChanged')
                  || isActionRequiredReason('externalDataChanged', ['firstName', 'fn'])
                  || !inspectedCandidate.firstName))
                ? { color:'red' } : {}">{{ $t('employee.core.firstName') }}</th>
              <td>{{ inspectedCandidate.firstName != null ? inspectedCandidate.firstName : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired
                && (isActionRequiredReason('missingdata', 'lastName') || isActionRequiredReason('coreDataChanged')
                || isActionRequiredReason('externalDataChanged', ['lastName', 'ln']) || !inspectedCandidate.lastName)
                ? { color:'red' } : {}">{{ $t('employee.core.lastName') }}</th>
              <td>{{ inspectedCandidate.lastName != null ? inspectedCandidate.lastName : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'maidenName')
              ? { color:'red' } : {}">{{ $t('employee.core.birthName') }}</th>
              <td>{{ inspectedCandidate.maidenName != null ? inspectedCandidate.maidenName : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired
                && (isActionRequiredReason('missingdata', 'dob') || isActionRequiredReason('coreDataChanged')
                || isActionRequiredReason('externalDataChanged', 'dob') || !inspectedCandidate.dob)
                ? { color:'red' } : {}">{{ $t('employee.core.birthdate') }}</th>
              <td>{{ inspectedCandidate.dob != null ? inspectedCandidate.dob : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'pob')
              ? { color:'red' } : {}">{{ $t('employee.core.birthPlace') }}</th>
              <td>{{ inspectedCandidate.pob != null ? inspectedCandidate.pob : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'cob')
              ? { color:'red' } : {}">{{ $t('employee.core.birthCountry') }}</th>
              <td>{{ inspectedCandidate.cob != null ? $t(`enum.country.${inspectedCandidate.cob}`) + " (" + inspectedCandidate.cob + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired
                && (isActionRequiredReason('missingdata', 'socialsecurity') || isActionRequiredReason('coreDataChanged')
                || isActionRequiredReason('externalDataChanged', ['socialsecurity', 'ss']) || !inspectedCandidate.socialsecurity)
                ? { color:'red' } : {}">{{ $t('employee.export.socialInsuranceNumber') }}</th>
              <td>{{ inspectedCandidate.socialsecurity != null ? inspectedCandidate.socialsecurity : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.externalEmployee') }}</th>
              <td>{{ (inspectedCandidate.external != null && inspectedCandidate.external ? $t('settings.ui.yes') : $t('settings.ui.no')) + " (" + inspectedCandidate.external + ")" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'gender')
              ? { color:'red' } : {}">{{ $t('employee.core.gender') }}</th>
              <td>{{ inspectedCandidate.gender != null ? $t(`enum.gender.${genderCandidateArray[inspectedCandidate.gender]}`) + " (" + inspectedCandidate.gender + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired &&
                (isActionRequiredReason('missingData', 'email') || isActionRequiredReason('inputdata','email')
                || isActionRequiredReason('externalDataChanged', 'email') || !inspectedCandidate.email)
                ? { color:'red' } : {}">E-Mail</th>
              <td>{{ inspectedCandidate.email != null ? inspectedCandidate.email : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['civilStatusId', 'csi'])
              ? { color:'red' } : {}">{{ $t('employee.core.maritalStatus') }}</th>
              <td>{{ inspectedCandidate.civilStatusId != null ? $t(`enum.civilStatus.${inspectedCandidate.civilStatusId}`) + " (" + inspectedCandidate.civilStatusId + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['citizenTypeId', 'ctid'])
              ? { color:'red' } : {}">{{ $t('employee.core.citizenType') }}</th>
              <td>{{ inspectedCandidate.citizenTypeId != null ? $t(`enum.citizenType.${inspectedCandidate.citizenTypeId}`) + " (" + inspectedCandidate.citizenTypeId + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['nationality', 'nat'])
              ? { color:'red' } : {}">Nationalität</th>
              <td>{{ inspectedCandidate.nationality != null ? $t(`enum.country.${inspectedCandidate.nationality}`) + " (" + inspectedCandidate.nationality + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && (isActionRequiredReason('externalDataChanged', 'address') || !inspectedCandidate.address)
              ? { color:'red' } : {}">Adresse</th>
              <td>{{ inspectedCandidate.address != null ? inspectedCandidate.address : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && (isActionRequiredReason('externalDataChanged', ['postalCode', 'pc']) || !inspectedCandidate.postalCode)
              ? { color:'red' } : {}">{{ $t('employee.core.postalCode') }}</th>
              <td>{{ inspectedCandidate.postalCode != null ? inspectedCandidate.postalCode : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && (isActionRequiredReason('externalDataChanged', 'city') || !inspectedCandidate.city)
              ? { color:'red' } : {}">{{ $t('employee.core.city') }}</th>
              <td>{{ inspectedCandidate.city != null ? inspectedCandidate.city : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'country')
              ? { color:'red' } : {}">{{ $t('employee.core.country') }}</th>
              <td>{{ inspectedCandidate.country != null ? $t(`enum.country.${inspectedCandidate.country}`) + " (" + inspectedCandidate.country + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['mobilephone', 'mp'])
              ? { color:'red' } : {}">{{ $t('employee.export.mobilePhone') }}</th>
              <td>{{ inspectedCandidate.mobilephone != null ? inspectedCandidate.mobilephone : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['homephone', 'hp'])
              ? { color:'red' } : {}">{{ $t('employee.export.landline') }}</th>
              <td>{{ inspectedCandidate.homephone != null ? inspectedCandidate.homephone : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['bankAccountHolder', 'bah'])
              ? { color:'red' } : {}">{{ $t('employee.export.accountHolder') }}</th>
              <td>{{ inspectedCandidate.bankAccountHolder != null ? inspectedCandidate.bankAccountHolder : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'iban')
              ? { color:'red' } : {}">IBAN</th>
              <td>{{ inspectedCandidate.iban != null ? inspectedCandidate.iban : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'bic')
              ? { color:'red' } : {}">BIC</th>
              <td>{{ inspectedCandidate.bic != null ? inspectedCandidate.bic : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.miscInfo') }}</th>
              <td>{{ inspectedCandidate.miscInfo != null ? inspectedCandidate.miscInfo : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.emergencyContact') + ' '}} {{ $t('settings.groups.name') }}</th>
              <td>{{ inspectedCandidate.guardianName != null ? inspectedCandidate.guardianName : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.emergencyContact') + ' '}} {{ $t('employee.core.relationship') }}</th>
              <td>{{ inspectedCandidate.guardianRelationship != null ? inspectedCandidate.guardianRelationship : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.emergencyContact') + ' '}} {{ $t('employee.core.address') }}</th>
              <td>{{ inspectedCandidate.guardianAddress != null ? inspectedCandidate.guardianAddress : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.emergencyContact') + ' '}} {{ $t('employee.core.phone') }}</th>
              <td>{{ inspectedCandidate.guardianPhone != null ? inspectedCandidate.guardianPhone : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.firstAidCourse') }}</th>
              <td>{{ inspectedCandidate.firstaidcourse != null ? inspectedCandidate.firstaidcourse : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.firstAidCourseExpiry') }}</th>
              <td>{{ inspectedCandidate.faExpiry != null ? inspectedCandidate.faExpiry : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.driversLicense') }}</th>
              <td>{{ inspectedCandidate.driverslicense != null ? inspectedCandidate.driverslicense : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.driversLicenseExpiry') }}</th>
              <td>{{ inspectedCandidate.dlExpiry != null ? inspectedCandidate.dlExpiry : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.import.pregnant') }}</th>
              <td>{{ inspectedCandidate.pregnant != null ? inspectedCandidate.pregnant : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.core.disability50') }}</th>
              <td>{{ inspectedCandidate.disability != null ? inspectedCandidate.disability : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['allocationGroup', 'ag'])
              ? { color:'red' } : {}">{{ $t('employee.core.payrollGroup') }}</th>
              <td>{{ inspectedCandidate.allocationGroup != null ? inspectedCandidate.allocationGroup : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['workEntryDate', 'wed'])
              ? { color:'red' } : {}">{{ $t('employee.core.firstEntryDate') }}</th>
              <td>{{ inspectedCandidate.workEntryDate != null ? inspectedCandidate.workEntryDate : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.import.workExperience') }}</th>
              <td>{{ inspectedCandidate.workExperience != null ? inspectedCandidate.workExperience : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.import.nonEmploymentTime') }}</th>
              <td>{{ inspectedCandidate.nonEmploymentTime != null ? inspectedCandidate.nonEmploymentTime : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'wpu')
              ? { color:'red' } : {}">{{ $t('employee.import.workPermitUntil') }}</th>
              <td>{{ inspectedCandidate.workPermitUntil != null ? inspectedCandidate.workPermitUntil : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'rpu')
              ? { color:'red' } : {}">{{ $t('employee.import.residencePermitUntil') }}</th>
              <td>{{ inspectedCandidate.residencePermitUntil != null ? inspectedCandidate.residencePermitUntil : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'app')
              ? { color:'red' } : {}">{{ $t('employee.import.prorationSetting') }}</th>
              <td>{{ inspectedCandidate.accPeriodPriority != null ? inspectedCandidate.accPeriodPriority : $t('employee.import.automatic') }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'ccc')
              ? { color:'red' } : {}">{{ $t('employee.contract.contract') + ' ' + $t('comp.ui.costCenter')}} ID</th>
              <td>{{ inspectedCandidate.costCenterId != null ?
                      (costCenterArray.find(c => c.id === parseInt(inspectedCandidate.costCenterId)) ?
                        inspectedCandidate.costCenterId + " (" + costCenterArray.find(c => c.id === parseInt(inspectedCandidate.costCenterId)).name + ")"
                        : inspectedCandidate.costCenterId)
                    : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['paymentType', 'pt'])
              ? { color:'red' } : {}">{{ $t('employee.import.paymentType') }}</th>
              <td>{{ inspectedCandidate.paymentType != null ? $t(`enum.paymentType.${inspectedCandidate.paymentType}`) + " (" + inspectedCandidate.paymentType + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['wageType', 'wt'])
              ? { color:'red' } : {}">{{ $t('employee.contract.wageType') }}</th>
              <td>{{ inspectedCandidate.wageType != null ? $t(`enum.wageType.${inspectedCandidate.wageType}`) + " (" + inspectedCandidate.wageType + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', 'payment')
              ? { color:'red' } : {}">{{ $t('employee.export.payment') }}</th>
              <td>{{ inspectedCandidate.payment != null ? inspectedCandidate.payment / 100.0 : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th>{{ $t('employee.contract.contract') + ' '}} {{ $t('employee.contract.comment') }}</th>
              <td>{{ inspectedCandidate.contractComment != null ? inspectedCandidate.contractComment : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['collectiveContractId', 'ccid'])
              ? { color:'red' } : {}">{{ $t('employee.import.collectiveAgreementId') }}</th>
              <td>{{ inspectedCandidate.collectiveContractId != null ? inspectedCandidate.collectiveContractId : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['jobName', 'jn'])
              ? { color:'red' } : {}">{{ $t('employee.contract.job') }}</th>
              <td>{{ inspectedCandidate.jobName != null ? inspectedCandidate.jobName : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['contractType', 'ct'])
              ? { color:'red' } : {}">{{ $t('employee.contract.contractType') }}</th>
              <td>{{ inspectedCandidate.contractType != null ? $t(`enum.contractType.${inspectedCandidate.contractType}`) + " (" + inspectedCandidate.contractType + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['contractStart', 'cs'])
              ? { color:'red' } : {}">{{ $t('employee.contract.contractStart') }}</th>
              <td>{{ inspectedCandidate.contractStart != null ? inspectedCandidate.contractStart : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['contractEnd', 'ce'])
              ? { color:'red' } : {}">{{ $t('employee.import.contractEnd') }}</th>
              <td>{{ inspectedCandidate.contractEnd != null ? inspectedCandidate.contractEnd : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['exitReason', 'er'])
              ? { color:'red' } : {}">{{ $t('employee.contract.exitReason') }}</th>
              <td>{{ inspectedCandidate.exitReason != null ? $t(`enum.exitReason.${inspectedCandidate.exitReason}`) + " (" + inspectedCandidate.exitReason + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['employeeCategory', 'ec'])
              ? { color:'red' } : {}">{{ $t('employee.import.employeeCategory') }}</th>
              <td>{{ inspectedCandidate.employeeCategory != null ? $t(`enum.employeeCategory.${inspectedCandidate.employeeCategory}`) + " (" + inspectedCandidate.employeeCategory + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['employmentType', 'et'])
              ? { color:'red' } : {}">{{ $t('employee.contract.employmentType') }}</th>
              <td>{{ inspectedCandidate.employmentType != null ? $t(`enum.employmentType.${inspectedCandidate.employmentType}`) + " (" + inspectedCandidate.employmentType + ")" : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['weekTimeRegular', 'wtr'])
              ? { color:'red' } : {}">{{ $t('employee.contract.weeklyHours') }}</th>
              <td>{{ inspectedCandidate.weekTimeRegular != null ? inspectedCandidate.weekTimeRegular / 60.0 : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['monthTimeRegular', 'mtr'])
              ? { color:'red' } : {}">{{ $t('employee.import.monthlyHours') }}</th>
              <td>{{ inspectedCandidate.monthTimeRegular != null ? inspectedCandidate.monthTimeRegular / 60.0 : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['weekWorkDaysRegular', 'wwdr'])
              ? { color:'red' } : {}">{{ $t('employee.import.workdaysPerWeek') }}</th>
              <td>{{ inspectedCandidate.weekWorkDaysRegular != null ? inspectedCandidate.weekWorkDaysRegular : "&nbsp;" }}</td>
            </tr>
            <tr>
              <th v-bind:style="inspectedCandidate.actionRequired && isActionRequiredReason('externalDataChanged', ['vacationTime', 'vt'])
              ? { color:'red' } : {}">{{ $t('employee.import.vacationDays') }}</th>
              <td>{{ inspectedCandidate.vacationTime != null ? inspectedCandidate.vacationTime : "&nbsp;" }}</td>
            </tr>
          </table>
        </div>
      </b-container>
      <template slot="modal-footer">
        <div class="button right" @click="closeSingleCandidatesModal()">
          <div class="label">{{ $t('global.ui.close') }}</div>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" ref="modal-external-data-changed" @close="closeExternalDataChangedModal()" centered>
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">
              {{ $t('employee.import.dataChangeIn') }} {{ importJob.id != null ? importJob.method : "" }}!
          </div>
        </div>
      </template>
      <b-container fluid>
        <div class="full">
            <div class="description">
                {{ $t('employee.import.changesDetectedIn') }} {{ importJob.id != null ? importJob.method : "" }}.<br/>
                {{ $t('employee.import.reviewAndConfirm') }}<br/><br/>
            </div>
            <div>
                {{ $t('employee.import.employeeToProcess') }}
            </div>
            <div class="emp-core-data">
            <div v-if="profilePictureUrl != null">
              <img
                style="margin: 4px; width: 120px; height: 120px"
                crossorigin="anonymous"
                id="employee-picture-img"
                :src="profilePictureUrl"
              />
            </div>
            <div>
              {{ $t('employee.doc.name') }}: <b>{{ externalImportEmployee.firstName + " " + externalImportEmployee.lastName }}</b>
              <br>
              {{ $t('employee.core.birthdate') }}: <b>{{ formatDate(externalImportEmployee.dob) }}</b>
              <br>
              {{ $t('employee.export.socialInsuranceNumber') }}: <b>{{ externalImportEmployee.socialsecurity }}</b>
            </div>
          </div>
            <div v-if="!externalImportCandidate.storeId" style="color:red">
                <b>{{ $t('employee.import.warning') }}</b>
                {{ $t('employee.import.storeNotFound') }}
            </div>
            <div>
            <br>{{ $t('employee.export.changedData') }}:
          </div>
          <table style="width: 100%">
            <tr>
              <th>{{ $t('employee.export.field') }}</th>
              <th>{{ $t('employee.import.dataInMl') }}</th>
              <th>{{ $t('employee.import.importedData') }}</th>
            </tr>
            <tr v-for="field in externalImportIssueFieldsComputed" v-bind:key="field.field">
              <th>{{ field.field }}</th>
              <td>{{ field.employee }}</td>
              <td>{{ field.candidate }}</td>
            </tr>
          </table>
        </div>
      </b-container>
      <template slot="modal-footer">
        <div class="buttons">
          <div class="button ml" v-bind:class="{ disabled: loadingDownload || loadingExport }" @click="forceEmployeeUpdateFromCandidate(externalImportCandidate); closeExternalDataChangedModal()">
            <div class="label">{{ $t('employee.import.applyChanges') }}</div>
          </div>
          <div class="button" v-bind:class="{ disabled: loadingDownload || loadingExport }" @click="skipEmployeeCandidate(); closeExternalDataChangedModal()">
            <div class="label">{{ $t('employee.import.rejectChanges') }}</div>
          </div>
          <div v-if="employeeSyncSetting && employeeSyncSetting.enableExportViaTransferService && employeeSyncSettingsData.enableExportViaTransferService
                    && !(employeeSyncSetting.enablePeriodicExport && employeeSyncSettingsData.enablePeriodicExport)"
               class="button" v-bind:class="{ disabled: loadingExport }" @click="triggerCsvExport(externalImportEmployee.id)">
            <div class="label">{{ $t('employee.import.rejectAndExportTo') }} {{ importJob.id != null ? importJob.method : "" }}</div>
          </div>
          <div v-if="employeeSyncSetting && !(employeeSyncSetting.enableExportViaTransferService && employeeSyncSettingsData.enableExportViaTransferService)"
               class="button" v-bind:class="{ disabled: loadingDownload }" @click="downloadCSV(externalImportEmployee.id)">
            <div class="label">{{ $t('employee.import.rejectAndDownloadFor') }} {{ importJob.id != null ? importJob.method : "" }}</div>
          </div>
        </div>

      </template>
    </b-modal>

    <b-modal size="lg" ref="modal-external-data-changed-matching" @close="closeExternalDataChangedMatchingModal()" centered>
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">
            {{ $t('employee.import.linkEmployee') }}
          </div>
        </div>
      </template>
      <b-container fluid>
        <div class="full">
          <div class="description">
              {{ $t('employee.import.changesDetectedForLinking') }}<br/>
              {{ $t('employee.import.reviewAndConfirm') }}<br/><br/>
          </div>
          <div>
            {{ $t('employee.import.employeeToLink') }}
          </div>
          <div class="emp-core-data">
            <div v-if="matchingProfilePictureUrl != null">
              <img
                style="margin: 4px; width: 120px; height: 120px"
                crossorigin="anonymous"
                id="employee-picture-img"
                :src="matchingProfilePictureUrl"
              />
            </div>
            <div>
              {{ $t('employee.doc.name') }}: <b>{{ matchingEmployee ? matchingEmployee.firstName + " " + matchingEmployee.lastName : "" }}</b>
              <br>
              {{ $t('employee.core.birthdate') }}: <b>{{ matchingEmployee ? formatDate(matchingEmployee.dob) : "" }}</b>
              <br>
              {{ $t('employee.export.socialInsuranceNumber') }}: <b>{{ matchingEmployee ? matchingEmployee.socialsecurity : "" }}</b>
            </div>
          </div>
          <div>
            <br>{{ $t('employee.export.changedData') }}:
          </div>
          <table style="width: 100%">
            <tr>
              <th>{{ $t('employee.export.field') }}</th>
              <th>{{ $t('employee.import.dataInMl') }}</th>
              <th>{{ $t('employee.import.importedData') }}</th>
            </tr>
            <tr v-for="field in matchingIssueFields" v-bind:key="field.field">
              <th>{{ field.field }}</th>
              <td>{{ field.employee }}</td>
              <td>{{ field.candidate }}</td>
            </tr>
          </table>
        </div>
      </b-container>
      <template slot="modal-footer">
        <div class="buttons">
          <div class="button ml" v-bind:class="{ disabled: loadingDownload || loadingExport }" @click="matchEmployeeWithCandidate(matchingCandidate, matchingEmployee); closeExternalDataChangedMatchingModal()">
            <div class="label">{{ $t('employee.import.linkEmployee') }}</div>
          </div>
          <div class="button" v-bind:class="{ disabled: loadingDownload || loadingExport }" @click="skipEmployeeCandidate(); closeExternalDataChangedMatchingModal()">
            <div class="label">{{ $t('employee.import.doNotLinkEmployee') }}</div>
          </div>
          <div class="button" v-bind:class="{ disabled: loadingDownload || loadingExport }" @click="closeExternalDataChangedMatchingModal()">
            <div class="label">{{ $t('settings.ui.cancel') }}</div>
          </div>
        </div>

      </template>
    </b-modal>

  </div>

</template>

<script>
import VueEventBus from '../../vue-event-bus';
import {mapState, mapGetters} from 'vuex';
import Papa from "papaparse";

export default {
  components: {},
  name: 'employeeImportJobs',
  data() {
    return {
      loading: true,

      importJob: {
        id: null,
        method: null
      },
      externalImportCandidate: {},
      externalImportEmployee: {},
      externalImportIssueFields: [],
      profilePictureUrl: null,

      matchingCandidate: {},
      matchingEmployee: {},
      matchingIssueFields: [],
      matchingProfilePictureUrl: null,

      candidates: [],
      importCandidates: [],

      employeeCandidateDiffId: null,

      inspectedCandidate: {},
      inspectedCandidates: [],
      inspectedCandidatesJob: {},

      candidateActions: {},

      jobs: [],
      filteredJobs: [],
      jobsPerPage: 10,
      currentPage: 1,

      employees: [],
      employeeContracts: [],
      allowedContracts: [],
      employeeDocuments: {},

      filterDropdownOptions: [],

      genderCandidateArray: {
        "M": 1,
        "F": 2,
        "D": 3
      },

      employeeSyncSetting: undefined,
      employeeSyncSettingsData: {
        enableExportViaTransferService: false,
        enablePeriodicExport: false,
      },

      loadingDownload: false,
      loadingExport: false,

      companyData: null,
      enableImport: false,
    }
  },
  created: function () {
    //console.log("CREATED");
    VueEventBus.$on("JobEmployeeImportEvent:jobCreated", this.jobCreated);
    VueEventBus.$on("JobEmployeeImportEvent:jobStarted", this.jobStarted);
    VueEventBus.$on("JobEmployeeImportEvent:jobEnded", this.jobEnded);
  },
  beforeDestroy: function () {
    VueEventBus.$off("JobEmployeeImportEvent:jobCreated", null);
    VueEventBus.$off("JobEmployeeImportEvent:jobStarted", null);
    VueEventBus.$off("JobEmployeeImportEvent:jobEnded", null);
  },
  mounted: function () {
    let view = this;
    this.LoadFilterDropdown();
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters(['companyId', 'isSuperUser', 'uiDataMap', 'storeArray', 'costCenterArray', 'externalSoftwaresMap',
            'countryEnumMap', 'genderEnumMap', 'citizentypeEnumMap', 'civilstatusEnumMap']),
    dateDisplay: function () {
      return this.$helpers.getMomentTZ().format('YYYY-MM-DD');
    },
    headerButtons() {
      let view = this;
      let state = {
        buttons: [
          // BUTTONS WHILE NO JOB IS SELECTED
          {
            type: "block border-r",
            icon: "fa-refresh",
            show: view.importJob.id == null,
            click: () => {
              view.refresh(true);
            },
            tooltip: view.$t('settings.notes.reloadData')
          },
          {
            type: "block border-r",
            icon: "fa-cloud-upload-alt",
            show: view.importJob.id == null,
            click: () => {
              view.openImportFromMDConfirmationPopup();
            },
            tooltip: view.$t('employee.import.loadingEmployeesFromMd')
          },
          {
            type: "block border-r",
            icon: "fa-file-csv",
            show: view.importJob.id == null && view.enableImport,
            click: () => {
              view.openCSVImportPopup();
            },
              tooltip: view.$t('employee.import.importEmployeeDataWith') + " " + view.software,
              helperText:
                  view.$t('employee.import.importEmployeeDataWith') +
                  " " +
                  view.software +
                  " " +
                  view.$t('employee.import.importEmployeeDataDescription'),
              externalUrl:
              "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2599256065",
          },

          // BUTTONS WHILE JOB IS SELECTED
          {
            type: "block border-r",
            icon: "fa-chevron-left",
            show: view.importJob.id != null,
            click: () => {
              view.clearSelection();
            },
            tooltip: view.$t('employee.import.back')
          },
          {
            type: "block",
            icon: "fa-ban",
            show: view.importJob.id != null,
            click: () => {
              view.openSkipAllConfirmationPopup();
            },
            tooltip: view.$t('employee.import.importNone')
          },
          {
            type: "block border-r",
            icon: "fa-magnifying-glass",
            show: view.importJob.id != null,
            click: () => {
              view.openAllCandidatesModal(view.importJob);
            },
            tooltip: view.$t('employee.import.showAllCandidates')
          },
        ],
          helperLinks: [
              {
                  title: this.$t('employee.import.importJobs'),
                  helperText: this.$t('employee.import.helperTextImportSystems'),
                  externalUrl:
                      "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2640084993",
                  externalLabel: this.$t('employee.import.learnMore'),
                  cancelLabel: this.$t('employee.import.thanks'),
                  icon: "fa-rotate"
              },
              {
                  title: this.$t('employee.import.getSupport'),
                  helperText: this.$t('employee.import.helperTextSupport'),
                  externalUrl:
                      "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11",
                  externalLabel: view.$t('settings.sync.contactSupport'),
                  cancelLabel: view.$t('global.ui.close')
              }
          ]
      };
      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [],
      };
      state.buttons.push({
        type: "block",
        icon: "fa-eye",
        tooltip: view.$t('comp.ui.displayFilter'),
        click: ($event) => {
          view.OpenFilterDropdown($event);
        },
      });
      return state;
    },
    software() {
      let view = this;
      if (view.companyData != null && view.externalSoftwaresMap[view.companyData.softwareId]) {
        return view.externalSoftwaresMap[view.companyData.softwareId].name;
      } else {
        return this.$t('employee.export.payrollTool');
      }
    },
    paginatedFilteredJobs() {
      let view = this;

      let indexStart = (view.currentPage - 1) * view.jobsPerPage;
      let indexEnd = indexStart + view.jobsPerPage;

      return Object.values(view.filteredJobs).slice(indexStart, indexEnd);
    },
    pages() {
      let view = this;
      let pages = Math.ceil(Object.values(view.filteredJobs).length / view.jobsPerPage);
      if (pages === 0) {
        pages = 1;
      }
      return pages;
    },
    formattedCurrentPage() {
      let view = this;
      let formattedPage = "";
      for (let i = 1; this.pages / i > 10; i*=10) {
        if (view.currentPage < i*10) {
          formattedPage += '\xa0\xa0';
        }
      }
      return formattedPage + view.currentPage;
    },
    externalImportIssueFieldsComputed() {
      let view = this;
      if (view.externalImportIssueFields.length > 0 && view.externalImportCandidate != null && !view.externalImportCandidate.storeId) {
        return view.externalImportIssueFields.filter(field => field.requiresStoreId === false);
      }
      return view.externalImportIssueFields;
    },
    genderArray() {
      return Object.values(this.genderEnumMap).map(c => {
        return {id: c.id, code: c.id, value: c.id, label: this.$t(`enum.gender.${c.id}`), name: this.$t(`enum.gender.${c.id}`)};
      });
    },
    countryArray() {
      return Object.values(this.countryEnumMap).map(c => {
        return {code: c.id, label: this.$t(`enum.country.${c.id}`), name: this.$t(`enum.country.${c.id}`)};
      });
    },
    citizenshipArray() {
      return Object.values(this.countryEnumMap).map(c => {
        return {code: c.id, label: this.$t(`enum.country.${c.id}`), name: this.$t(`enum.country.${c.id}`)};
      });
    },
    cobArray() {
      return Object.values(this.countryEnumMap).map(c => {
        return {code: c.id, label: this.$t(`enum.country.${c.id}`), name: this.$t(`enum.country.${c.id}`)};
      });
    },
    citizenTypeArray() {
      return Object.values(this.citizentypeEnumMap).map(c => {
        return {id: c.id, code: c.id, value: c.key, label: this.$t(`enum.citizenType.${c.id}`), name: this.$t(`enum.citizenType.${c.id}`)};
      });
    },
    civilStatusArray() {
      return Object.values(this.civilstatusEnumMap).map(c => {
        return {id: c.id, code: c.id, value: c.key, label: this.$t(`enum.civilStatus.${c.id}`), name: this.$t(`enum.civilStatus.${c.id}`)};
      });
    },
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh();
    },
    filterDropdownOptions: {
      handler (val, oldVal) {
        this.filterJobs();
      },
      deep: true
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      console.log("REFRESH");
      console.log("uiDataMap", this.uiDataMap);
      let view = this;

      view.currentPage = 1;
      view.loading = true;
      view.jobs = [];
      view.filteredJobs = [];
      view.importJob = {
        id: null,
        method: null
      };
      view.externalImportCandidate = {};
      view.employees = [];
      view.candidates = [];
      view.candidateActions = {};
      view.inspectedCandidate = {};
      view.inspectedCandidates = [];

      view.employeeSyncSetting = undefined;
      view.employeeSyncSettingsData = {
        enableExportViaTransferService: false,
          enablePeriodicExport: false,
      };

      view.$helpers.GetExternalSoftwaresMap();
      view.$helpers
        .GetCompanySettings(force)
        .then((response) => {
          view.updateCompanySettings(response);
          view.getEmployeeSyncSettings()
            .then((settings) => {
              view.employeeSyncSetting = settings.find(res => {
                return res.softwareId === view.companyData.softwareId
              });
              if (view.employeeSyncSetting !== undefined) {
                view.getEmployeeSyncSettingsData()
                  .then((data) => {
                    view.employeeSyncSettingsData = data;
                    view.enableImport = true;
                  });
              }
            });
        });
      view.loadEmployeeImportJobs();
      view.selectImportJob(view.importJob);

      // load following data in the background
      view.loadEmployees();
      view.loadEmployeeContracts();
      view.$helpers.GetStoresSettings()
        .then(response => {
          response.data.forEach(store => {
            this.loadAllowedContracts(store.id);
          });
        });
      view.$helpers.GetEmployeeDocumentsMap(force).then((response) => {
        view.employeeDocuments = {};
        Object.values(response).filter(x => !x.proxyDocument).forEach(doc => {
            if(view.employeeDocuments[doc.employeeId] == undefined){
                view.employeeDocuments[doc.employeeId] = [];
            }
            view.employeeDocuments[doc.employeeId].push(doc);
        });
        console.log(view.employeeDocuments);
      });
      view.$helpers.GetCostCenterArray(force);
    },
    clearSelection: function () {
      let view = this;
      view.importJob = {
        id: null,
        method: null
      };
      view.externalImportCandidate = {};
      view.inspectedCandidates = [];
    },

    loadEmployees: function (force = false, employeeIdToSelect = null) {
      let view = this;
      this.api
        .get("/sec/employee/coredata")
        .then((response) => {
          let empls = response.data.data;
          this.employees = empls;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadEmployeeContracts() {
      let view = this;
      let url = '/api/sec/proxy/md/employee/contracts';

      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/proxy/md/employee/contracts');

      this.axios({
        method: 'get',
        headers: {
          'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      }).then(response => {
        if (response.data !== undefined) {
          response.data.sort((a, b) => {
            if (a.from > b.from) {
              return 1;
            } else if (a.from < b.from) {
              return -1;
            }
            return 0;
          });
          // only save the latest contract per employee/store
          response.data.forEach(entry => {
            if (view.employeeContracts[entry.remoteId] === undefined) {
              view.employeeContracts[entry.remoteId] = [];
            }
            view.employeeContracts[entry.remoteId][entry.storeId] = entry;
          });
        }
      });
    },
    loadAllowedContracts(storeId) {
      let view = this;
      let url = '/api/sec/proxy/md/allowedContracts';
      view.allowedContracts = [];

      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/proxy/md/allowedContracts');
      url = this.$helpers.appendParam("storeId", storeId, url, '/api/sec/proxy/md/allowedContracts');

      this.axios({
        method: 'get',
        headers: {
          'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      }).then(response => {
        if (response.data !== undefined) {
          view.allowedContracts[storeId] = [];
          response.data.forEach(allowedContract => {
            view.allowedContracts[storeId][allowedContract.id] = allowedContract;
          });
        }
      });
    },

    updateCompanySettings: function (response) {
      let view = this;

      if (response.data.length === 1) {
        view.companyData = response.data[0];
      }
    },

    jobCreated: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB CREATED EVENT GOT TRIGGERED");
        view.refresh();
      }, 50);
    },
    jobStarted: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB STARTED EVENT GOT TRIGGERED");
        view.refresh();
      }, 100);
    },
    jobEnded: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB ENDED EVENT GOT TRIGGERED");
        view.refresh();
      }, 200);
    },

    selectImportJob: function (job) {
      this.importJob = job;
      if (job != null) {
        this.loadEmployeeImportCandidates();
      } else {
        //this.candidates = [];
        this.employeeCandidateDiffId = null;
      }
    },
    checkCandidateAction: function (candidate) {
      this.employeeCandidateDiffId = candidate.id;
      if (candidate.actionRequiredReason === "internalEmployeeNotFound") {
        this.createEmployee(candidate);
      } else if (candidate.actionRequiredReason === "coreDataChanged") { // import from MD / MDCORE has differences
        this.loadEmployeeCandidateDiff()
          .then((response) => {
            this.openCoreDataIssuePopup(candidate, response.data);
          });
      } else if (candidate.actionRequiredReason &&
        (candidate.actionRequiredReason.substring(0,9) === "inputdata" || candidate.actionRequiredReason.substring(0,11) === "missingdata")) {
        this.openInputIssuePopup(candidate);
      } else if (candidate.actionRequiredReason && candidate.actionRequiredReason.substring(0,19) === "externalDataChanged") {
        this.openExternalDataChangedModal(candidate);
      } else {
        console.log("Unknown issue: " + candidate.actionRequiredReason);
        this.openUnknownIssuePopup(candidate);
      }
    },
    isActionRequiredReason(reason, data = null) {
      if (this.inspectedCandidate.actionRequiredReason !== null &&
          this.inspectedCandidate.actionRequiredReason !== undefined &&
          this.inspectedCandidate.actionRequiredReason.substring(0, reason.length) === reason) {
        if (data) {
          let reasonArray = this.inspectedCandidate.actionRequiredReason.split(":");
          if (reasonArray.length > 1) {
            let dataArray = reasonArray[1].split(",");
            if (Array.isArray(data)) {
              let val = false;
              data.forEach((elem) => {
                if (dataArray.includes(elem)) {
                  val = true;
                }
              });
              return val;
            }
            if (dataArray.includes(data)) {
              return true;
            }
            return false;
          }
          return false;
        }
        return true;
      }
      return false;
    },

    openImportFromMDConfirmationPopup() {
      let view = this;

      let entries = [];
        let description = this.$t('employee.import.confirmImport');

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            positiveButtonLabel: "Importieren!",
            selectCallback: function (item) {
              view.startImportFromExternalSystem("md");
            },
          },
          header: this.$t('employee.import.importFromMd'),
          centered: true,
          expanded: true,
        });
      });
    },
    startImportFromExternalSystem: function (mode) {
      let view = this;
      let url = '/api/employee/importJob';
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      let payload = {
        jobMethod: mode
      }


      this.axios({
        method: 'post',
        headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
        url: url,
        data: payload
      }).then(response => {
        console.log(response.data.data);
        view.loadEmployeeImportJobs();
      }).catch(function (error) {
        console.log(error);
      })

    },

    loadEmployeeImportJobs: function (force = false) {
      let view = this;
      let baseUrl = '/api/employee/importJob';
      let url = this.$helpers.appendParam("companyId", this.$store.state.companyId, baseUrl, baseUrl);

      this.axios({
        method: 'get',
        headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
        url: url,
      }).then(response => {
        // load and show first page of data
        view.jobs = response.data.data;
        this.filterJobs();

        Object.values(view.jobs).forEach((elem) => {
          elem.jobStartedConverted = elem.jobStarted != null ? view.$helpers.convertUTCDateStringTZ(elem.jobStarted, 'DD.MM.YYYY HH:mm:ss') : null;
          elem.jobEndedConverted = elem.jobEnded != null ? view.$helpers.convertUTCDateStringTZ(elem.jobEnded, 'DD.MM.YYYY HH:mm:ss') : null;
        });
        view.loading = false;

        // call other pages
        if (response.data.last_page > 1) {
          console.log(response.data.current_page);
          console.log(response.data.last_page);
          view.loadEmployeeImportJobsPages(baseUrl, response.data.current_page + 1, response.data.last_page)
          .then((response) => {
            this.filterJobs();

            Object.values(view.jobs).forEach((elem) => {
              elem.jobStartedConverted = elem.jobStarted != null ? view.$helpers.convertUTCDateStringTZ(elem.jobStarted, 'DD.MM.YYYY HH:mm:ss') : null;
              elem.jobEndedConverted = elem.jobEnded != null ? view.$helpers.convertUTCDateStringTZ(elem.jobEnded, 'DD.MM.YYYY HH:mm:ss') : null;
            });
          });
        }

      }).catch(function (error) {
        console.log(error);
      })
    },
    loadEmployeeImportJobsPages(baseUrl, page, lastPage) {
      let view = this;
      if (page <= lastPage) {
        let url = this.$helpers.appendParam("companyId", view.$store.state.companyId, baseUrl, baseUrl);
        url = this.$helpers.appendParam("page", page, url, baseUrl);

        return view.axios({
          method: 'get',
          headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
          url: url,
        }).then(response => {
          view.jobs = view.jobs.concat(response.data.data);
          return view.loadEmployeeImportJobsPages(baseUrl, page + 1, lastPage);
        }).catch(function (error) {
          console.log(error);
        });
      }


    },
    loadEmployeeImportCandidates: function (importjob = null, force = false) {
      let view = this;
      view.inspectedCandidates = [];

      if (importjob == null) {
        importjob = this.importJob;
      }
      if (force || !view.candidates[importjob.id]) {
        view.candidates[importjob.id] = [];
      }

      if ((importjob.id != null) && (view.candidates[importjob.id].length == 0)) {
        console.log("loading candidates");
        let baseUrl = '/api/employee/candidate/all';
        let url = baseUrl;
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);
        url = this.$helpers.appendParam("employeeImportJobId", importjob.id, url, baseUrl);

        this.axios({
          method: 'get',
          headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
          url: url,
        }).then(response => {
          let candidates = response.data.data.sort((a,b) => {
            // sort by lastName, firstName, remoteId, contractStart
            if (a.lastName < b.lastName) {
              return -1;
            } else if (a.lastName > b.lastName) {
              return 1;
            } else if (a.firstName < b.firstName) {
              return -1;
            } else if (a.firstName > b.firstName) {
              return 1;
            } else if (a.remoteId < b.remoteId) {
              return -1;
            } else if (a.remoteId > b.remoteId) {
              return 1;
            } else if (a.contractStart > b.contractStart) {
              return 1;
            } else {
              return -1;
            }
        });
          view.candidates[importjob.id] = candidates;
          view.inspectedCandidates = candidates;

          view.loadEmployeeImportCandidateActionsTaken(importjob.id);

        }).catch(function (error) {
          console.log(error);
        })
      } else {
        view.inspectedCandidates = view.candidates[importjob.id];
      }
    },
    loadEmployeeImportCandidateActionsTaken: function (importJobId) {
      let view = this;
      let baseUrl = '/api/employee/candidate/actions';
      let url = baseUrl;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);
      url = this.$helpers.appendParam("employeeImportJobId", importJobId, url, baseUrl);

      this.axios({
        method: 'get',
        headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
        url: url,
      }).then(response => {
        console.log(response);
        response.data.forEach(action => {
          action.actionTakenAtConverted = action.actionTakenAt != null ? view.$helpers.convertUTCDateStringTZ(action.actionTakenAt, 'DD.MM.YYYY HH:mm:ss') : null;
          view.candidateActions[action.employeeCandidateId] = action;
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadEmployeeCandidateDiff: function (force = false) {
      let view = this;
      let baseUrl = '/api/employee/candidate/diff';
      let url = '/api/employee/candidate/diff';
      url = this.$helpers.appendParam("employeeCandidateId", this.employeeCandidateDiffId, url, baseUrl);
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);
      url = this.$helpers.appendParam("employeeImportJobId", this.importJob.id, url, baseUrl);

      return this.axios({
        method: 'get',
        headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
        url: url,
      }).catch(function (error) {
        console.log(error);
      })
    },
    skipEmployeeCandidate: function (force = false) {
      let view = this;
      let url = '/api/employee/candidate/skip';
      let payload = {
        employeeCandidateId: this.employeeCandidateDiffId,
        companyId: this.$store.state.companyId,
        employeeImportJobId: this.importJob.id,
      };

      this.axios({
        method: 'put',
        headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
        url: url,
        data: payload
      }).then(response => {
        Object.values(view.candidates[view.importJob.id]).forEach((elem, index) => {
          if (this.employeeCandidateDiffId === elem.id) {
            elem.actionRequired = 0;
          }
        });
        const count = view.candidates[view.importJob.id].filter(elem => {
          if (elem.actionRequired === 1) {
            return true;
          }
          return false;
        }).length;
        if (count === 0) {
          view.refresh();
        }
      }).catch(function (error) {
        console.log(error);
      })
    },
    skipAllEmployeeCandidates: function (force = false) {
      let view = this;
      let url = '/api/employee/candidate/skip/all';
      let payload = {
        companyId: this.$store.state.companyId,
        employeeImportJobId: this.importJob.id,
      };

      this.axios({
        method: 'put',
        headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
        url: url,
        data: payload
      }).then(response => {
        this.refresh();
      }).catch(function (error) {
        console.log(error);
      })
    },
    openSkipAllConfirmationPopup() {
      let view = this;

      let entries = [];
      let description = this.$t('employee.import.confirmNoEntry');

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            selectCallback: function (item) {
              view.skipAllEmployeeCandidates();
            },
          },
          header: this.$t('employee.import.importNone'),
          centered: true,
          expanded: true,
        });
      });
    },

    createEmployee(candidate) {
      this.$helpers.log(this, "createEmployee", candidate);
      this.getCandidates(candidate).then((response) => {
        let candidatesResponse = response.data.data;
        let selectableItems = this.transformCandidateResult(candidatesResponse);
        if (selectableItems.length > 0) {
          this.openCandidateChooserPopup(candidate, selectableItems).then((remoteId) => {
            if (remoteId === 0) {
              // console.log("mitabeiter nicht importieren");
              this.skipEmployeeCandidate();
            } else if (remoteId != null) {
              // console.log("mitabeiter matchen: " + remoteId);
              this.checkEmployeeDataForCandidateMatching(candidate, remoteId);
            } else {
              // console.log("mitabeiter neu anlegen");
              this.saveNewEmployee(candidate);
            }
          });
        } else {
          this.openSingleCandidateCreatorPopup(candidate).then((remoteId) => {
            if (remoteId === 0) {
              // console.log("mitabeiter nicht importieren");
              this.skipEmployeeCandidate();
            } else {
              // console.log("mitabeiter neu anlegen");
              this.saveNewEmployee(candidate);
            }
          });
        }
      }).catch((error) => {
        // this should happen, when there is an error during getting candidates
        this.openSingleCandidateCreatorPopup(candidate).then((remoteId) => {
          if (remoteId === 0) {
            // console.log("mitabeiter nicht importieren");
            this.skipEmployeeCandidate();
          } else {
            // console.log("mitabeiter neu anlegen");
            this.saveNewEmployee(candidate);
          }
        });
      });
    },
    saveNewEmployee(candidate) {
      let view = this;
      let payload = {
        candidateId: candidate.id
      };

      let url = "/sec/employee/candidate/create";
      this.api.post(url, payload).then((response) => {
        console.log(response);
        if (response.status == 200) {
          view.$helpers.success(view.$t('employee.core.saved'), view.$t('employee.core.employeeSaved'));
          Object.values(view.candidates[view.importJob.id]).forEach((elem, index) => {
            if (this.employeeCandidateDiffId === elem.id) {
              elem.actionRequired = 0;
            }
          });
        }
      }).catch((error) => {
        console.log(error.response.data.message);
        if (error.response.data.message.substring(0,16) === "inputdata:email:") {
            view.$helpers.error(
                view.$t('global.messages.error'),
                this.$t('employee.import.emailExistsSystem')
            );
        } else if (error.response.data.message.substring(0,12) === "missingdata:") {
            view.$helpers.error(
                view.$t('global.messages.error'),
                this.$t('employee.import.missingData')
            );
        } else {
            view.$helpers.error(
                view.$t('global.messages.error'),
                this.$t('employee.import.createFailed')
            );
        }
      });
    },
    checkEmployeeDataForCandidateMatching(candidate, remoteId) {
      let view = this;
      // console.log("checkEmployeeDataForCandidateMatching");

      view.matchingIssueFields = [];
      view.matchingCandidate = candidate;

      let employee = view.employees.find(emp => emp.id === remoteId);
      view.matchingEmployee = employee;

      // check for differences if employee exists in ML DB, otherwise create it
      if (view.matchingEmployee) {

        let contract = view.employeeContracts[employee.id] !== undefined ? view.employeeContracts[employee.id][candidate.storeId] : undefined;
        view.matchingProfilePictureUrl = view.GetProfilePictureUrl(employee, 'large', true);

        if ((view.matchingEmployee.firstName ?? "") !== (view.matchingCandidate.firstName ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.firstName'),
            employee: view.matchingEmployee.firstName,
            candidate: view.matchingCandidate.firstName
          });
        }
        if ((view.matchingEmployee.lastName ?? "") !== (view.matchingCandidate.lastName ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.lastName'),
            employee: view.matchingEmployee.lastName,
            candidate: view.matchingCandidate.lastName
          });
        }
        if ((view.matchingEmployee.dob ?? "") !== (view.matchingCandidate.dob ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('settings.average.birthDate'),
            employee: view.matchingEmployee.dob,
            candidate: view.matchingCandidate.dob
          });
        }
        if ((view.matchingEmployee.socialsecurity ?? "") !== (view.matchingCandidate.socialsecurity ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.export.socialInsuranceNumber'),
            employee: view.matchingEmployee.socialsecurity,
            candidate: view.matchingCandidate.socialsecurity
          });
        }
        if (view.matchingEmployee.genderId !== (view.genderCandidateArray.hasOwnProperty(view.matchingCandidate.gender) ?
                  view.genderCandidateArray[view.matchingCandidate.gender] : 0)) {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.gender'),
            employee: view.$t(`enum.gender.${view.matchingEmployee.genderId}`),
            candidate: view.genderCandidateArray.hasOwnProperty(view.matchingCandidate.gender) ?
                  view.$t(`enum.gender.${view.genderCandidateArray[view.matchingCandidate.gender]}`) :
                  view.$t(`enum.gender.0`)
          });
        }
        if ((view.matchingEmployee.email ?? "") !== (view.matchingCandidate.email ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.email'),
            employee: view.matchingEmployee.email,
            candidate: view.matchingCandidate.email
          });
        }
        if ((view.matchingEmployee.civilStatusId ?? "") + "" !== (view.matchingCandidate.civilStatusId ?? "")+"") {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.maritalStatus'),
            employee: view.$t(`enum.civilStatus.${view.matchingEmployee.civilStatusId ?? 0}`),
            candidate: view.$t(`enum.civilStatus.${view.matchingCandidate.civilStatusId ?? 0}`)
          });
        }
        if ((view.matchingEmployee.citizenTypeId ?? "") + "" !== (view.matchingCandidate.citizenTypeId ?? "")+"") {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.citizenType'),
            employee: view.$t(`enum.citizenType.${view.matchingEmployee.citizenTypeId ?? 0}`),
            candidate: view.$t(`enum.citizenType.${view.matchingCandidate.citizenTypeId ?? 0}`)
          });
        }
        if ((view.matchingEmployee.citizenshipId ?? "") + "" !== (view.matchingCandidate.nationality ?? "0")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.export.nationality'),
            employee: view.$t(`enum.country.${view.matchingEmployee.citizenshipId ?? 0}`),
            candidate: view.$t(`enum.country.${view.matchingCandidate.nationality ?? 0}`)
          });
        }
        if ((view.matchingEmployee.address ?? "") !== (view.matchingCandidate.address ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.export.address'),
            employee: view.matchingEmployee.address,
            candidate: view.matchingCandidate.address
          });
        }
        if ((view.matchingEmployee.postalCode ?? "") !== (view.matchingCandidate.postalCode ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.postalCode'),
            employee: view.matchingEmployee.postalCode,
            candidate: view.matchingCandidate.postalCode
          });
        }
        if ((view.matchingEmployee.city ?? "") !== (view.matchingCandidate.city ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.city'),
            employee: view.matchingEmployee.city,
            candidate: view.matchingCandidate.city
          });
        }
        if ((view.matchingEmployee.countryId ?? "") + "" !== (view.matchingCandidate.country ?? "0")) {
          console.log("country mismatch", view.matchingEmployee.countryId, view.matchingCandidate.country);
          view.matchingIssueFields.push({
            field: this.$t('employee.export.country'),
            employee: view.$t(`enum.country.${view.matchingEmployee.countryId ?? 0}`),
            candidate: view.$t(`enum.country.${view.matchingCandidate.country ?? 0}`)
          });
        }
        if ((view.matchingEmployee.mobilephone ?? "") !== (view.matchingCandidate.mobilephone ?? "")) {
          view.matchingIssueFields.push({
            field: this.$t('employee.export.mobilePhone'),
            employee: view.matchingEmployee.mobilephone,
            candidate: view.matchingCandidate.mobilephone
          });
        }
        if ((view.matchingEmployee.homephone ?? "") !== (view.matchingCandidate.homephone ?? "")) {
          view.matchingIssueFields.push({
            field: this.$t('employee.export.landline'),
            employee: view.matchingEmployee.homephone,
            candidate: view.matchingCandidate.homephone
          });
        }
        if ((view.matchingEmployee.bankAccountHolder ?? "") !== (view.matchingCandidate.bankAccountHolder ?? "")) {
          view.matchingIssueFields.push({
            field: this.$t('employee.export.accountHolder'),
            employee: view.matchingEmployee.bankAccountHolder,
            candidate: view.matchingCandidate.bankAccountHolder
          });
        }
        if ((view.matchingEmployee.iban ?? "") !== (view.matchingCandidate.iban ?? "")) {
          view.matchingIssueFields.push({
            field: "IBAN",
            employee: view.matchingEmployee.iban,
            candidate: view.matchingCandidate.iban
          });
        }
        if ((view.matchingEmployee.bic ?? "") !== (view.matchingCandidate.bic ?? "")) {
          view.matchingIssueFields.push({
            field: "BIC",
            employee: view.matchingEmployee.bic,
            candidate: view.matchingCandidate.bic
          });
        }
        if ((view.matchingEmployee.allocationGroup ?? "") !== (view.matchingCandidate.allocationGroup ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.payrollGroup'),
            employee: view.matchingEmployee.allocationGroup,
            candidate: view.matchingCandidate.allocationGroup
          });
        }
        if (this.formatDate(view.matchingEmployee.workEntryDate) !== this.formatDate(view.matchingCandidate.workEntryDate)) {
          view.matchingIssueFields.push({
            field: view.$t('employee.core.firstEntryDate'),
            employee: this.formatDate(view.matchingEmployee.workEntryDate),
            candidate: this.formatDate(view.matchingCandidate.workEntryDate)
          });
        }
        if ((view.matchingEmployee.mdPersonnelId ?? "") !== (view.matchingCandidate.personnelId ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('global.ui.pNumber'),
            employee: view.matchingEmployee.mdPersonnelId,
            candidate: view.matchingCandidate.personnelId
          });
        }
        if ((view.matchingEmployee.taxId ?? "") !== (view.matchingCandidate.taxId ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('global.ui.taxId'),
            employee: view.matchingEmployee.taxId,
            candidate: view.matchingCandidate.taxId
          });
        }
        if ((contract != null ? contract.paymentType+"" : "") !== (view.matchingCandidate.paymentType ?? "")+"") {
          view.matchingIssueFields.push({
            field: view.$t('employee.import.paymentType'),
            employee: contract != null ? view.$t(`enum.paymentType.${contract.paymentType ?? 0}`) : "",
            candidate: view.$t(`enum.paymentType.${view.matchingCandidate.paymentType ?? 0}`)
          });
        }
        if ((contract != null ? contract.wageType+"" : "") !== (view.matchingCandidate.wageType ?? "")+"") {
          view.matchingIssueFields.push({
            field: view.$t('employee.contract.wageType'),
            employee: contract != null ? view.$t(`enum.wageType.${contract.wageType ?? 0}`) : "",
            candidate: view.$t(`enum.wageType.${view.matchingCandidate.wageType ?? 0}`)
          });
        }
        if ((contract != null ? contract.payment / 100.0 : "") !== view.matchingCandidate.payment / 100.0) {
          view.matchingIssueFields.push({
            field: this.$t('employee.export.payment'),
            employee: contract != null ? contract.payment / 100.0 : "",
            candidate: view.matchingCandidate.payment / 100.0
          });
        }
        if ((contract != null ? view.allowedContracts[contract.storeId][contract.collectiveContractId].collectiveContractId : "") !== view.matchingCandidate.collectiveContractId) {
          view.matchingIssueFields.push({
            field: view.$t('employee.import.collectiveAgreementId'),
            employee: contract != null ? view.allowedContracts[contract.storeId][contract.collectiveContractId].collectiveContractId : "",
            candidate: view.matchingCandidate.collectiveContractId
          });
        }
        if ((contract != null ? contract.jobName : "") !== (view.matchingCandidate.jobName ?? "")) {
          view.matchingIssueFields.push({
            field: view.$t('employee.contract.job'),
            employee: contract != null ? contract.jobName : "",
            candidate: view.matchingCandidate.jobName
          });
        }
        if ((contract != null ? contract.contractType+"" : "") !== (view.matchingCandidate.contractType ?? "")+"") {
          view.matchingIssueFields.push({
            field: view.$t('employee.contract.contractType'),
            employee: contract != null ? view.$t(`enum.contractType.${contract.contractType ?? 0}`) : "",
            candidate: view.$t(`enum.contractType.${view.matchingCandidate.contractType ?? 0}`)
          });
        }
        if ((contract != null ? this.formatDate(contract.from) : "") !== this.formatDate(view.matchingCandidate.contractStart)) {
          view.matchingIssueFields.push({
            field: view.$t('employee.contract.contractStart'),
            employee: contract != null ? this.formatDate(contract.from) : "",
            candidate: this.formatDate(view.matchingCandidate.contractStart)
          });
        }
        if ((contract != null ? this.formatDate(contract.to) : "") !== this.formatDate(view.matchingCandidate.contractEnd)) {
          view.matchingIssueFields.push({
            field: view.$t('employee.contract.contractEnd'),
            employee: contract != null ? this.formatDate(contract.to) : "",
            candidate: this.formatDate(view.matchingCandidate.contractEnd)
          });
        }
        if ((contract != null ? contract.exitReason : "") !== view.matchingCandidate.exitReason) {
          view.matchingIssueFields.push({
            field: view.$t('employee.contract.exitReason'),
            employee: contract != null ? view.$t(`enum.exitReason.${contract.exitReason}`) : "",
            candidate: view.$t(`enum.exitReason.${view.matchingCandidate.exitReason}`)
          });
        }
        if ((contract != null ? contract.employeeCategory+"" : "") !== (view.matchingCandidate.employeeCategory ?? "")+"") {
          view.matchingIssueFields.push({
            field: this.$t('employee.export.employeeCategory'),
            employee: contract != null ? view.$t(`enum.employeeCategory.${contract.employeeCategory ?? 0}`) : "",
            candidate: view.$t(`enum.employeeCategory.${view.matchingCandidate.employeeCategory ?? 0}`)
          });
        }
        if ((contract != null ? contract.employmentType+"" : "") !== (view.matchingCandidate.employmentType ?? "")+"") {
          view.matchingIssueFields.push({
            field: view.$t('employee.contract.employmentType'),
            employee: contract != null ? view.$t(`enum.employmentType.${contract.employmentType ?? 0}`) : "",
            candidate: view.$t(`enum.employmentType.${view.matchingCandidate.employmentType ?? 0}`)
          });
        }
        if ((contract != null ? contract.weekTimeRegular / 60.0 : "") !== view.matchingCandidate.weekTimeRegular / 60.0) {
          view.matchingIssueFields.push({
            field: view.$t('employee.contract.weeklyHours'),
            employee: contract != null ? contract.weekTimeRegular / 60.0 : "",
            candidate: view.matchingCandidate.weekTimeRegular / 60.0
          });
        }
        if ((contract != null ? (Math.round((view.allowedContracts[contract.storeId][contract.collectiveContractId].monthTimeRegular / 60.0 + Number.EPSILON) * 100) / 100) : "")
          !== (view.matchingCandidate.monthTimeRegular ? (Math.round((view.matchingCandidate.monthTimeRegular / 60.0 + Number.EPSILON) * 100) / 100) : "")) {
          view.matchingIssueFields.push({
            field: this.$t('employee.export.monthlyHours'),
            employee: contract != null ? (Math.round((view.allowedContracts[contract.storeId][contract.collectiveContractId].monthTimeRegular / 60.0 + Number.EPSILON) * 100) / 100) : "",
            candidate: view.matchingCandidate.monthTimeRegular ? (Math.round((view.matchingCandidate.monthTimeRegular / 60.0 + Number.EPSILON) * 100) / 100) : ""
          });
        }
        if ((contract != null ? (contract.weekWorkDaysRegular+"").trim() : "") !== (view.matchingCandidate.weekWorkDaysRegular+"").trim()) {
          view.matchingIssueFields.push({
            field: this.$t('employee.export.workdaysPerWeek'),
            employee: contract != null ? contract.weekWorkDaysRegular : "",
            candidate: view.matchingCandidate.weekWorkDaysRegular
          });
        }
        if ((contract != null ? contract.vacationTime / 60 / 24 : "") !== view.matchingCandidate.vacationTime) {
          view.matchingIssueFields.push({
            field: view.$t('employee.import.vacationDays'),
            employee: contract != null ? contract.vacationTime / 60 / 24 : "",
            candidate: view.matchingCandidate.vacationTime
          });
        }
      }

      if (view.matchingIssueFields.length > 0) {
        this.openExternalDataChangedMatchingModal();
      } else {
        if (!employee) {
          employee = {
            id: remoteId
          };
        }
        this.matchEmployeeWithCandidate(candidate, employee);
      }
    },
    matchEmployeeWithCandidate(candidate, employee) {
      let view = this;
      let payload = {
        candidateId: candidate.id,
        remoteId: employee.id
      };

      let url = "/sec/employee/candidate/match";
      this.api.post(url, payload).then((response) => {
        console.log(response);
        if (response.status == 200) {
          view.$helpers.success(view.$t('employee.core.saved'), view.$t('employee.core.employeeSaved'));
          Object.values(view.candidates[view.importJob.id]).forEach((elem, index) => {
            if (this.employeeCandidateDiffId === elem.id) {
              elem.actionRequired = 0;
            }
          });
          const count = view.candidates[view.importJob.id].filter(elem => {
            if (elem.actionRequired === 1) {
              return true;
            }
            return false;
          }).length;
          if (count === 0) {
            view.refresh();
          }
        }
      }).catch((error) => {
        if (error.response.data.data.email) {
            view.$helpers.error(
                view.$t('global.messages.error'),
                this.$t('employee.import.emailExistsOther') + error.response.data.data.email
            );
        } else {
            view.$helpers.error(
                view.$t('global.messages.error'),
                this.$t('employee.import.linkFailed')
            );
        }
      });
    },
    forceEmployeeUpdateFromCandidate(candidate) {
      let view = this;
      let payload = {
        candidateId: candidate.id,
        remoteId: candidate.remoteId
      };

      let url = "/sec/employee/candidate/update/force";
      this.api.post(url, payload).then((response) => {
        console.log(response);
        if (response.status == 200) {
          view.$helpers.success(view.$t('employee.core.saved'), view.$t('employee.core.employeeSaved'));
          Object.values(view.candidates[view.importJob.id]).forEach((elem, index) => {
            if (this.employeeCandidateDiffId === elem.id) {
              elem.actionRequired = 0;
            }
          });
          const count = view.candidates[view.importJob.id].filter(elem => {
            if (elem.actionRequired === 1) {
              return true;
            }
            return false;
          }).length;
          if (count === 0) {
            view.refresh();
          }
        }
      }).catch((error) => {
        if (error.response.data.data && error.response.data.data.email) {
            view.$helpers.error(
                view.$t('global.messages.error'),
                this.$t('employee.import.emailExistsOther') + error.response.data.data.email
            );
        } else {
          view.$helpers.error(view.$t('global.messages.error'), view.$t('employee.export.updateFailed'));
        }
      });
    },
    doEmployeeUpdateWithoutCoreDataFromCandidate(candidate) {
      let view = this;
      let payload = {
        candidateId: candidate.id,
        remoteId: candidate.remoteId
      };

      let url = "/sec/employee/candidate/update/nocoredata";
      this.api.post(url, payload).then((response) => {
        console.log(response);
        if (response.status == 200) {
          view.$helpers.success(view.$t('employee.core.saved'), view.$t('employee.core.employeeSaved'));
          Object.values(view.candidates[view.importJob.id]).forEach((elem, index) => {
            if (this.employeeCandidateDiffId === elem.id) {
              elem.actionRequired = 0;
            }
          });
          const count = view.candidates[view.importJob.id].filter(elem => {
            if (elem.actionRequired === 1) {
              return true;
            }
            return false;
          }).length;
          if (count === 0) {
            view.refresh();
          }
        }
      }).catch((error) => {
        if (error.response.data.data.email) {
            view.$helpers.error(
                view.$t('global.messages.error'),
                this.$t('employee.import.emailExistsOther') + error.response.data.data.email
            );
        } else {
          view.$helpers.error(view.$t('global.messages.error'), view.$t('employee.export.updateFailed'));
        }
      });
    },

    // trigger CSV export
    triggerCsvExport(remoteId) {
      let view = this;

      view.loadingExport = true;

      let url = '/api/sec/employeesync/export';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);
      url = this.$helpers.appendParam("softwareId", view.companyData.softwareId, url, baseurl);
      url = this.$helpers.appendParam("remoteIds", [remoteId], url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.$helpers.info(
          view.$t('global.messages.info'),
          view.$t('employee.export.exportTriggered')
        );
        view.skipEmployeeCandidate();
        view.closeExternalDataChangedModal();
        view.loadingExport = false;
      }).catch((e) => {
        view.exporting = false;
        view.$helpers.error(
          view.$t('global.messages.error'),
          view.$t('settings.help.createExportError')
        );
        view.loadingExport = false;
      });
    },
    // CSV download
    downloadCSV(remoteId) {
      let view = this;
      view.loadingDownload = true;

      let url = '/api/sec/employeesync/getexport';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);
      url = this.$helpers.appendParam("softwareId", view.companyData.softwareId, url, baseurl);
      url = this.$helpers.appendParam("remoteIds", [remoteId], url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        let csv = response.data.data;
        view.$helpers.forceFileDownload(view.$helpers.b64DecodeUnicode(csv), "Export.csv");
        view.skipEmployeeCandidate();
        view.closeExternalDataChangedModal();
        view.loadingDownload = false;
      }).catch((e) => {
        view.$helpers.error(
          view.$t('global.messages.error'),
          view.$t('settings.help.createExportError')
        );
        view.loadingDownload = false;
      });
    },

    getCandidates(employee) {
      let url = "/sec/employee/proxyMDCoreCandidate";
      url = this.$helpers.appendParam("firstName", employee.firstName, url, "/sec/employee/proxyMDCoreCandidate");
      url = this.$helpers.appendParam("lastName", employee.lastName, url, "/sec/employee/proxyMDCoreCandidate");
      if (employee.dob != null) url = this.$helpers.appendParam("dob", this.$helpers.extractDateString(employee.dob), url, "/sec/employee/proxyMDCoreCandidate");
      if (employee.socialsecurity != null) url = this.$helpers.appendParam("socialsecurity", employee.socialsecurity, url, "/sec/employee/proxyMDCoreCandidate");
      console.log(url);
      return this.api.get(url);
    },
    transformCandidateResult(candidateResult) {
      let candidates = candidateResult.candidates;
      let matches = candidateResult.matches;
      let selectableItems = [];
      candidates.forEach((candidate) => {
        let bd = candidate.date_of_birth != null ? this.$helpers.getMomentFromStringTZ(candidate.date_of_birth).format("DD.MM.YYYY") : "";
        let item = {
          label: candidate.firstname + " " + candidate.lastname + " " + bd + " (" + this.$t('employee.doc.match') + ": " + candidate.score + "%)",
          value: candidate.id,
          score: candidate.score,
        };
        selectableItems.push(item);
      });
      matches.forEach((candidate) => {
        let bd = candidate.date_of_birth != null ? this.$helpers.getMomentFromStringTZ(candidate.date_of_birth).format("DD.MM.YYYY") : "";
        let item = {
          label: candidate.firstname + " " + candidate.lastname + " " + bd + " 100%",
          value: candidate.id,
          score: 100,
        };
        selectableItems.push(item);
      });
      selectableItems.sort((a, b) => {
        return -(a.score - b.score);
      });
      return selectableItems;
    },
    openCandidateChooserPopup(newEmployee, selectableItems) {
      let view = this;
      let entries = [];

      selectableItems.unshift({
        label: this.$t('employee.import.createNew'),
        value: null,
      });

      let description =
        this.$t('employee.import.noMatchFound') +
        this.$t('employee.import.foundSimilar') +
        this.$t('employee.import.linkOrCreate');

      entries.push({
        label: view.$t('settings.wage.pleaseSelect'),
        key: "remoteId",
        hidden: false,
        type: "dropdownsearch",
        value: null,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: selectableItems,
          selectMultiple: false,
          selectedItems: [],
          selectFirst: true,
          styleLight: true,
        },
      });

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            selectCallback: function (item) {
              resolve(item.remoteId);
            },
            negativeButtonLabel: this.$t('employee.import.notImport'),
            deleteCallback: function (item) {
              resolve(0);
            },
          },
          header: this.$t('employee.import.checkEmployee') + ": " + newEmployee.firstName + " " + newEmployee.lastName,
          centered: true,
          expanded: true,
        });
      });
    },
    openSingleCandidateCreatorPopup(newEmployee) {
      let view = this;
      let entries = [];

      let description =
        this.$t('employee.import.noMatchFound') +
        this.$t('employee.import.createNewHint');

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            positiveButtonLabel: view.$t('settings.wage.createNew'),
            selectCallback: function (item) {
              resolve(null);
            },
            negativeButtonLabel: this.$t('employee.import.notImport'),
            deleteCallback: function (item) {
              resolve(0);
            },
          },
          header: this.$t('employee.import.checkEmployee') + ": " + newEmployee.firstName + " " + newEmployee.lastName,
          centered: true,
          expanded: true,
        });
      });
    },
    openUnknownIssuePopup(candidate) {
      let view = this;

      let style = { 'padding-left': '10px', 'margin': '0px' };
      let valueStyle = { 'margin': '0px' };

      let entries = [
        {key: 'importId', type: 'output', styles: style, valueStyles: valueStyle, value: candidate.employeeImportId, label:'Import ID'},
        {key: 'internalId', type: 'output', styles: style, valueStyles: valueStyle, value: candidate.remoteId, label:this.$t('employee.data.internalId')},
        {key: 'externalId', type: 'output', styles: style, valueStyles: valueStyle, value: candidate.externalId, label:this.$t('employee.import.externalId')},
        {key: 'firstname', type: 'output', styles: style, valueStyles: valueStyle, value: candidate.firstName, label:this.$t('employee.ui.firstName')},
        {key: 'lastname', type: 'output', styles: style, valueStyles: valueStyle, value: candidate.lastName, label:this.$t('employee.ui.lastName')},
        {key: 'dob', type: 'output', styles: style, valueStyles: valueStyle, value: candidate.dob, label:this.$t('settings.average.birthDate')},
        {key: 'socialsecurity', type: 'output', styles: style, valueStyles: valueStyle, value: candidate.socialsecurity, label:this.$t('employee.export.socialInsuranceNumber')},
      ];

      let description =
        this.$t('employee.import.problemUnknown') +
        this.$t('employee.import.contactSupport');

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            selectCallback: function (item) {
              view.skipEmployeeCandidate();
            },
            negativeButtonLabel: view.$t('settings.ui.cancel'),
            deleteCallback: function (item) {},
          },
          header: this.$t('employee.import.unknownProblem'),
          centered: true,
          expanded: true,
        });
      });
    },
    openInputIssuePopup(candidate) {
      let view = this;

      let style = { 'padding-left': '10px', 'margin': '0px' };
      let valueStyle = { 'margin': '0px' };

      let entries = [];
      let reasonArray = candidate.actionRequiredReason.split(":");

      let description = this.$t('employee.import.inputIssue') + " <br/> <br/>";

      if (reasonArray[0] === "inputdata") {
        if (reasonArray[1] === "email") {
          description += this.$t('employee.import.emailExistsSystem');

          if (reasonArray.length >= 3) {
            entries.push({
              key: 'issue',
              type: 'output',
              styles: style,
              valueStyles: valueStyle,
              value: reasonArray[2],
              label: reasonArray[1]
            });
          }
        }
      } else if (reasonArray[0] === "missingdata") {
        description += this.$t('employee.import.followingDataMissing') + ":<br/>";
        let missingDataArray = reasonArray[1].split(",");
        missingDataArray.forEach(missingData => {
          switch (missingData) {
            case "firstName": description += view.$t('employee.core.firstName') + "<br/>"; break;
            case "lastName": description += view.$t('employee.core.lastName') + "<br/>"; break;
            case "dob": description += view.$t('employee.core.birthdate') + "<br/>"; break;
            case "socialsecurity": description += view.$t('employee.export.socialInsuranceNumber') + "<br/>"; break;
            case "email": description += view.$t('settings.notes.emailAddress') + "<br/>"; break;
            default: break;
          }
        });
      }

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            selectCallback: function (item) {
              view.skipEmployeeCandidate();
            },
            negativeButtonLabel: view.$t('settings.ui.cancel'),
            deleteCallback: function (item) {

            },
          },
          header: this.$t('employee.import.inputProblem'),
          centered: true,
          expanded: true,
        });
      });
    },
    openExternalDataChangedIssuePopup(candidate) {
      let view = this;

      let style = { 'padding-left': '10px', 'margin': '0px' };
      let valueStyle = { 'margin': '0px' };

      let entries = [];
      let reasonArray = candidate.actionRequiredReason.split(":");

      let description = this.$t('employee.import.methodChangesDetected', { method: view.importJob.method }) + " <br/> <br/>";

      if (reasonArray[0] === "inputdata") {
        if (reasonArray[1] === "email") {
          description += this.$t('employee.import.emailExistsSystem');

          if (reasonArray.length >= 3) {
            entries.push({
              key: 'issue',
              type: 'output',
              styles: style,
              valueStyles: valueStyle,
              value: reasonArray[2],
              label: reasonArray[1]
            });
          }
        }
      } else if (reasonArray[0] === "missingdata") {
        description += this.$t('employee.import.followingDataMissing') + ":<br/>";
        let missingDataArray = reasonArray[1].split(",");
        missingDataArray.forEach(missingData => {
          switch (missingData) {
            case "firstName": description += view.$t('employee.core.firstName') + "<br/>"; break;
            case "lastName": description += view.$t('employee.core.lastName') + "<br/>"; break;
            case "dob": description += view.$t('employee.core.birthdate') + "<br/>"; break;
            case "socialsecurity": description += view.$t('employee.export.socialInsuranceNumber') + "<br/>"; break;
            case "email": description += view.$t('settings.notes.emailAddress') + "<br/>"; break;
            default: break;
          }
        });
      }

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            selectCallback: function (item) {
              // TODO: trigger saving of employee
            },
            positiveButtonLabel: view.$t('employee.import.applyChanges'),
            negativeButtonLabel: view.$t('employee.import.rejectChanges'),
            deleteCallback: function (item) {
              view.skipEmployeeCandidate();
            },
          },
          header: this.$t('employee.import.dataChangeInM', { method: this.importJob.method }),
          centered: true,
          expanded: true,
        });
      });
    },
    openCoreDataIssuePopup(candidate, diff) {
      let view = this;

      let style = { 'padding-left': '10px', 'margin': '0px' };
      let valueStyle = { 'margin': '0px' };

      let entries = [];

      let description =
          this.$t('employee.import.coreDataChanged') +
          " <br/> <br/>" +
          this.$t('employee.import.takeOverQuestion') + " <br/>";

      Object.values(diff).forEach((row) => {
          row.displayName = this.$t('employee.import.field') + " " + row.key;
          switch (row.key) {
              case "firstName": row.displayName = this.$t('employee.import.firstName');
                  break;
              case "lastName": row.displayName = this.$t('employee.import.lastName');
                  break;
              case "dob": row.displayName = this.$t('employee.import.dob');
                  break;
              case "socialsecurity": row.displayName = this.$t('employee.import.socialsecurity');
                  break;
              default:
                  break;
          }

          description +=
              row.displayName + " " + this.$t('employee.import.willChangeFrom') + " <strong>" + row.database +
              "</strong> " + this.$t('employee.import.to') + " <strong>" + row.candidate + "</strong>!" + "<br/>";
      });

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            selectCallback: function (item) {
              view.forceEmployeeUpdateFromCandidate(candidate);
            },
            deleteCallback: function (item) {
              view.doEmployeeUpdateWithoutCoreDataFromCandidate(candidate);
            },
              positiveButtonLabel: this.$t('employee.import.takeCoreData'),
              negativeButtonLabel: this.$t('employee.import.rejectCoreData')
          },
          header: this.$t('employee.import.coreDataChange'),
          centered: true,
          expanded: true,
        });
      });
    },

    getEmployeeSyncSettings() {
      return this.$helpers.GetCall('/api/sec/employeesync/settings').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    getEmployeeSyncSettingsData() {
      return this.$helpers.GetCall('/api/sec/employeesync/data').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },

    openCSVImportPopup() {
      let view = this;

      let description =
          this.$t('employee.import.uploadExport') + " <br/> " +
          this.$t('employee.import.ensureUtf8') + " <br/><br/>" +
          this.$t('employee.import.usesSyncSettings', ["<i class='fas fa-arrow-right' style='cursor: auto'></i>"]);

        let dataEntries = [
        {
          label: view.$t('employee.data.csvFile'),
          accept: ".csv",
          key: "file",
          hidden: false,
          type: "file",
          value: null,
          styles: {
            "padding-left": "10px",
          }
        },
      ];

      this.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        componentState: {
          entries: dataEntries,
          description: description,
          selectCallback: function (importf) {
            if (importf.file && importf.file.length > 0) {

              let read = new FileReader();
              read.readAsBinaryString(importf.file[0]);
              read.onloadend = function(){
                view.sendEmployeeImport(importf.file[0], read.result);
              }
            } else {
              view.$helpers.error(
                view.$t('global.messages.error'),
                view.$t('employee.doc.noImportFileSelected')
              );
            }
          },
          errorCheck: {
            'file': (entries) => {
              if (entries.file == null || entries.file.length == 0) {
                return {
                  key: 'file',
                  label: view.$t('employee.data.csvFile'),
                  type: 'error',
                  text: view.$t('employee.import.selectFile'),
                }
              }
              return null;
            },
          },
        },
        header: view.$t('employee.import.importWithSoftware', { software: view.software }),
        remainAfterSelect: false,
        expanded: true,
        centered: true,
      });
    },
    sendEmployeeImport(file, content) {
      let view = this;
      let payload = {
        source: view.software,
        filename: file.name,
        file: btoa(content)
      };

      let url = "/sec/employeesync/csvimport";
      return this.api.post(url, payload)
        .then((response) => {
          if (response.status === 202) {
            view.$helpers.success(view.$t('global.ui.success'), view.$t('employee.import.employeeJobStarted'));
            this.refresh();
          }
        }).catch((error) => {
          view.$helpers.error(view.$t('global.messages.error'), view.$t('employee.import.jobFailed') + error.response.data);
          this.refresh();
        });
    },

    OpenFilterDropdown($event) {
      var view = this;
      var target = $event.currentTarget;

      this.$helpers.OpenPopup({
        elRelative: target,
        type: "list",
        componentState: {
          entries: view.filterDropdownOptions,
        },
        remainAfterSelect: true,
        pointerDirection: 0,
        iconsLeft: true,
        selectCallback: function ($event, item, dropdown) {
          item.toggled = !item.toggled;
        },
      });
    },
    LoadFilterDropdown() {
      var view = this;
      this.filterDropdownOptions = [];
      view.filterDropdownOptions.push({
        label: this.$t('employee.import.action'),
        key: "action",
        isHeader: true,
      });
      view.filterDropdownOptions.push({
        label: this.$t('employee.import.actionRequired'),
        key: "action_required",
        toggled: true,
        color: "var(--ml)",
      });
      view.filterDropdownOptions.push({
        label: this.$t('employee.import.noActionRequired'),
        key: "no_action_required",
        toggled: true,
        color: "var(--ml)",
      });
      view.filterDropdownOptions.push({
        label: this.$t('employee.import.methods'),
        key: "methods",
        isHeader: true,
      });
      view.filterDropdownOptions.push({
        label: "SNS",
        key: "sns",
        toggled: false,
        color: "var(--ml)",
      });
      view.filterDropdownOptions.push({
        label: "MD",
        key: "md",
        toggled: true,
        color: "var(--ml)",
      });
      view.filterDropdownOptions.push({
        label: "CORE",
        key: "core",
        toggled: true,
        color: "var(--ml)",
      });
      view.filterDropdownOptions.push({
        label: this.$t('employee.import.externalLvTool'),
        key: "external",
        toggled: true,
        color: "var(--ml)",
      });
      view.filterDropdownOptions.push({
        label: this.$t('employee.import.other'),
        key: "other",
        toggled: true,
        color: "var(--ml)",
      });
      // view.filterDropdownOptions.push({
      //   label: "BMD",
      //   key: "bmd",
      //   toggled: true,
      //   color: "#000",
      // });
      // view.filterDropdownOptions.push({
      //   label: "DPW",
      //   key: "dpw",
      //   toggled: true,
      //   color: "#000",
      // });
      // view.filterDropdownOptions.push({
      //   label: "SOTEC",
      //   key: "sotec",
      //   toggled: true,
      //   color: "#000",
      // });
    },
    filterJobs() {
      let view = this;
      view.filteredJobs = [];
      Object.values(view.jobs).forEach((job) => {
        let noaction = view.filterDropdownOptions.find((option) => option.key === "no_action_required");
        let action = view.filterDropdownOptions.find((option) => option.key === "action_required");
        if ((noaction.toggled && job.actionRequired === 0) || (action.toggled && job.actionRequired === 1)) {
          let option = view.filterDropdownOptions.find((option) => option.key === job.method.toLowerCase());
          let external = view.filterDropdownOptions.find((option) => option.key === "external");
          let other = view.filterDropdownOptions.find((option) => option.key === "other");

          if (option !== undefined) {
            if (option.toggled === true) {
              view.filteredJobs.push(job);
            }
          } else if (Object.values(view.externalSoftwaresMap).find(software => software.name === job.method.toUpperCase())) {
            if (external.toggled) {
              view.filteredJobs.push(job);
            }
          } else if (other.toggled) {
            view.filteredJobs.push(job);
          }
        }
      });
    },
    GetProfilePictureUrl(employee, size = null, urlOnly = false) {
      let view = this;
      if (employee.employeePicture_fileId == null) {
        var port = location.port;
        var url =
          location.protocol +
          "//" +
          location.hostname +
          "/img/avatar.png";
        if (port != "80" && port != "443") {
          url =
            location.protocol +
            "//" +
            location.hostname +
            ":" +
            location.port +
            "/img/avatar.png";
        }

        if (urlOnly) return url;
        return "var(--contrast-1) no-repeat center/cover url(/img/avatar.png)";
      } else {
        var imgUrl =
          employee.employeePicture_server +
          "/api/file?id=" +
          employee.employeePicture_fileId +
          "&accessToken=" +
          employee.employeePicture_accessToken +
          "&s=" +
          this.imgCacheTimestamp;
        if (size) imgUrl = imgUrl + "&thumb=" + size;
        if (urlOnly) return imgUrl;
        return "var(--contrast-1) no-repeat center/cover  url(" + imgUrl + ")";
      }
    },
    formatDate(dateString) {
      if (dateString != null) {
        let d = new Date(dateString);
        return ("0" + d.getDate()).slice(-2) + "." + ("0"+(d.getMonth()+1)).slice(-2) + "." + d.getFullYear();
      }
      return null;
    },

    loadAndOpenCandidates(job) {
      let view = this;
      view.loadEmployeeImportCandidates(job);
      view.openAllCandidatesModal(job);
    },
    openAllCandidatesModal(job) {
      this.inspectedCandidatesJob = job;
      this.$refs["modal-all-candidates"].show();
    },
    closeAllCandidatesModal() {
      this.inspectedCandidatesJob = null;
      this.$refs["modal-all-candidates"].hide();
    },
    openSingleCandidatesModal(candidate) {
      // console.log(this.storeArray);
      this.inspectedCandidate = candidate;
      this.$refs["modal-single-candidate"].show();
    },
    closeSingleCandidatesModal() {
      this.$refs["modal-single-candidate"].hide();
    },
    openExternalDataChangedModal(candidate) {
      let view = this;
      view.externalImportIssueFields = [];
      view.externalImportCandidate = candidate;
      let reasonArray = candidate.actionRequiredReason.split(":");
      let fieldsArray = reasonArray[1].split(",");

      let employee = view.employees.find(emp => emp.id === candidate.remoteId);
      view.externalImportEmployee = employee;
      let contract = view.employeeContracts[employee.id] !== undefined ? view.employeeContracts[employee.id][candidate.storeId] : undefined;

      view.profilePictureUrl = view.GetProfilePictureUrl(employee, 'large', true);

      fieldsArray.forEach(field => {
        switch (field) {
          //storeId
          case "storeId":
          case "stid":
            view.externalImportIssueFields.push({
              field: "Store ID",
              employee: view.externalImportEmployee.storeId,
              candidate: view.externalImportCandidate.storeId,
              requiresStoreId: false
            });
            let empStore = view.storeArray ? view.storeArray.find(s => s.id == view.externalImportEmployee.storeId) : null;
            let candStore = view.storeArray ? view.storeArray.find(s => s.id == view.externalImportCandidate.storeId) : null;
            view.externalImportIssueFields.push({
              field: "Store",
              employee: empStore ? empStore.name : "",
              candidate: candStore ? candStore.name : "",
              requiresStoreId: false
            });
            break;
          //costCenter
          case "ccntid":
            view.externalImportIssueFields.push({
              field: view.$t('comp.ui.costCenter') + " ID",
              employee: view.externalImportEmployee.costCenterId,
              candidate: view.externalImportCandidate.costCenterId,
              requiresStoreId: false
            });
            // console.log("emp", view.externalImportEmployee);
            // console.log("costCenterArray", view.costCenterArray);
            // console.log("internal costcenter", view.externalImportEmployee.costCenterId);
            // console.log("candidate costcenter", view.externalImportCandidate.costCenterId);
            let empCostCenter = view.costCenterArray ? view.costCenterArray.find(s => s.id == view.externalImportEmployee.costCenterId) : null;
            let candCostCenter = view.costCenterArray ? view.costCenterArray.find(s => s.id == view.externalImportCandidate.costCenterId) : null;
            view.externalImportIssueFields.push({
              field: view.$t('comp.ui.costCenter'),
              employee: empCostCenter ? empCostCenter.name : "",
              candidate: candCostCenter ? candCostCenter.name : "",
              requiresStoreId: false
            });
            break;
          //firstName
          case "firstName":
          case "fn":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.firstName'),
              employee: view.externalImportEmployee.firstName,
              candidate: view.externalImportCandidate.firstName,
              requiresStoreId: false
            });
            break;
          //lastName
          case "lastName":
          case "ln":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.lastName'),
              employee: view.externalImportEmployee.lastName,
              candidate: view.externalImportCandidate.lastName,
              requiresStoreId: false
            });
            break;
          //dob
          case "dob":
            view.externalImportIssueFields.push({
              field: view.$t('settings.average.birthDate'),
              employee: this.formatDate(view.externalImportEmployee.dob),
              candidate: this.formatDate(view.externalImportCandidate.dob),
              requiresStoreId: false
            });
            break;
          //socialsecurity
          case "socialsecurity":
          case "ss":
            view.externalImportIssueFields.push({
              field: view.$t('employee.export.socialInsuranceNumber'),
              employee: view.externalImportEmployee.socialsecurity,
              candidate: view.externalImportCandidate.socialsecurity,
              requiresStoreId: false
            });
            break;
          //gender
          case "gender":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.gender'),
              employee: view.$t(`enum.gender.${view.externalImportEmployee.genderId}`),
              candidate: view.genderCandidateArray.hasOwnProperty(view.externalImportCandidate.gender) ?
                view.$t(`enum.gender.${view.genderCandidateArray[view.externalImportCandidate.gender]}`) :
                view.$t(`enum.gender.0`),
              requiresStoreId: false
            });
            break;
          //email
          case "email":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.email'),
              employee: view.externalImportEmployee.email,
              candidate: view.externalImportCandidate.email,
              requiresStoreId: false
            });
            break;
          //civilStatusId
          case "civilStatusId":
          case "csid":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.maritalStatus'),
              employee: view.$t(`enum.civilStatus.${view.externalImportEmployee.civilStatusId}`),
              candidate: view.$t(`enum.civilStatus.${view.externalImportCandidate.civilStatusId}`),
              requiresStoreId: false
            });
            break;
          //citizenTypeId
          case "citizenTypeId":
          case "ctid":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.citizenType'),
              employee: view.$t(`enum.citizenType.${view.externalImportEmployee.citizenTypeId}`),
              candidate: view.$t(`enum.citizenType.${view.externalImportCandidate.citizenTypeId}`),
              requiresStoreId: false
            });
            break;
          //nationality
          case "nationality":
          case "nat":
            view.externalImportIssueFields.push({
              field: view.$t('employee.export.nationality'),
              employee: view.$t(`enum.country.${view.externalImportEmployee.citizenshipId}`),
              candidate: view.$t(`enum.country.${view.externalImportCandidate.nationality}`),
              requiresStoreId: false
            });
            break;
          //address
          case "address":
            view.externalImportIssueFields.push({
              field: view.$t('employee.export.address'),
              employee: view.externalImportEmployee.address,
              candidate: view.externalImportCandidate.address,
              requiresStoreId: false
            });
            break;
          //postalCode
          case "postalCode":
          case "pc":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.postalCode'),
              employee: view.externalImportEmployee.postalCode,
              candidate: view.externalImportCandidate.postalCode,
              requiresStoreId: false
            });
            break;
          //city
          case "city":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.city'),
              employee: view.externalImportEmployee.city,
              candidate: view.externalImportCandidate.city,
              requiresStoreId: false
            });
            break;
          //country
          case "country":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.country'),
              employee: view.$t(`enum.country.${view.externalImportEmployee.countryId}`),
              candidate: view.$t(`enum.country.${view.externalImportCandidate.country}`),
              requiresStoreId: false
            });
            break;
          //mobilephone
          case "mobilephone":
          case "mp":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.mobilePhone'),
              employee: view.externalImportEmployee.mobilephone,
              candidate: view.externalImportCandidate.mobilephone,
              requiresStoreId: false
            });
            break;
          //homephone
          case "homephone":
          case "hp":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.landline'),
              employee: view.externalImportEmployee.homephone,
              candidate: view.externalImportCandidate.homephone,
              requiresStoreId: false
            });
            break;
          //bankAccountHolder
          case "bankAccountHolder":
          case "bah":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.accountHolder'),
              employee: view.externalImportEmployee.bankAccountHolder,
              candidate: view.externalImportCandidate.bankAccountHolder,
              requiresStoreId: false
            });
            break;
          //iban
          case "iban":
            view.externalImportIssueFields.push({
              field: "IBAN",
              employee: view.externalImportEmployee.iban,
              candidate: view.externalImportCandidate.iban,
              requiresStoreId: false
            });
            break;
          //allocationGroup
          case "allocationGroup":
          case "ag":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.payrollGroup'),
              employee: view.externalImportEmployee.allocationGroup,
              candidate: view.externalImportCandidate.allocationGroup,
              requiresStoreId: false
            });
            break;
          //bic
          case "bic":
            view.externalImportIssueFields.push({
              field: "BIC",
              employee: view.externalImportEmployee.bic,
              candidate: view.externalImportCandidate.bic,
              requiresStoreId: false
            });
            break;
          //workEntryDate
          case "workEntryDate":
          case "wed":
            view.externalImportIssueFields.push({
              field: view.$t('employee.core.firstEntryDate'),
              employee: this.formatDate(view.externalImportEmployee.workEntryDate),
              candidate: this.formatDate(view.externalImportCandidate.workEntryDate),
              requiresStoreId: false
            });
            break;
          //externalId
          case "externalId":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.externalId'),
              employee: view.importJob.method == "BMD" ? view.externalImportEmployee.bmdId : "",
              candidate: view.externalImportCandidate.externalId,
              requiresStoreId: false
            });
            break;
          //mdPersonnelId
          case "mdPersonnelId":
          case "mdpid":
            view.externalImportIssueFields.push({
              field: view.$t('global.ui.pNumber'),
              employee: view.externalImportEmployee.mdPersonnelId,
              candidate: view.externalImportCandidate.personnelId,
              requiresStoreId: false
            });
            break;
          //taxId
          case "taxId":
            view.externalImportIssueFields.push({
              field: view.$t('global.ui.taxId'),
              employee: view.externalImportEmployee.taxId,
              candidate: view.externalImportCandidate.taxId,
              requiresStoreId: false
            });
            break;
          //workPermitUntil
          case "wpu":
            view.externalImportIssueFields.push({
              field: view.$t('employee.import.workPermitUntil'),
              employee: view.getLatestValidUntilDate(view.externalImportEmployee.id, "WORKPERMIT"),
              candidate: view.formatDate(view.externalImportCandidate.workPermitUntil),
              requiresStoreId: false
            });
            break;
          //residencePermitUntil
          case "rpu":
            view.externalImportIssueFields.push({
              field: view.$t('employee.import.residencePermitUntil'),
              employee: view.getLatestValidUntilDate(view.externalImportEmployee.id, "RESIDENCEPERMIT"),
              candidate: view.formatDate(view.externalImportCandidate.residencePermitUntil),
              requiresStoreId: false
            });
            break;
          //accPeriodPriority
          case "app":
            view.externalImportIssueFields.push({
              field: view.$t('employee.import.prorationSetting'),
              employee: contract != null ? (contract.accPeriodPriority ? contract.accPeriodPriority : view.$t('employee.import.automatic')) : "",
              candidate: view.externalImportCandidate.accPeriodPriority ? view.externalImportCandidate.accPeriodPriority : view.$t('employee.import.automatic'),
              requiresStoreId: true
            });
            break;
          //contract costCenter
          case "ccc":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.contract') + " " + view.$t('comp.ui.costCenter') + " ID",
              employee: contract != null ? contract.costCenterId : "",
              candidate: view.externalImportCandidate.costCenterId,
              requiresStoreId: false
            });
            let contractCostCenter = contract != null && view.costCenterArray ? view.costCenterArray.find(s => s.id == contract.costCenterId) : null;
            let contractCandCostCenter = view.costCenterArray ? view.costCenterArray.find(s => s.id == view.externalImportCandidate.costCenterId) : null;
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.contract') + " " + view.$t('comp.ui.costCenter'),
              employee: contractCostCenter ? contractCostCenter.name : "",
              candidate: contractCandCostCenter ? contractCandCostCenter.name : "",
              requiresStoreId: false
            });
            break;
          //paymentType
          case "paymentType":
          case "pt":
            view.externalImportIssueFields.push({
              field: view.$t('employee.import.paymentType'),
              employee: contract != null ? view.$t(`enum.paymentType.${contract.paymentType}`) : "",
              candidate: view.$t(`enum.paymentType.${view.externalImportCandidate.paymentType}`),
              requiresStoreId: true
            });
            break;
          //wageType
          case "wageType":
          case "wt":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.wageType'),
              employee: contract != null ? view.$t(`enum.wageType.${contract.wageType}`) : "",
              candidate: view.$t(`enum.wageType.${view.externalImportCandidate.wageType}`),
              requiresStoreId: true
            });
            break;
          //payment
          case "payment":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.payment'),
              employee: contract != null ? contract.payment / 100.0 : "",
              candidate: view.externalImportCandidate.payment / 100.0,
              requiresStoreId: true
            });
            break;
          //collectiveContractId
          case "collectiveContractId":
          case "ccid":
            view.externalImportIssueFields.push({
              field: view.$t('employee.import.collectiveAgreementId'),
              employee: contract != null ? view.allowedContracts[contract.storeId][contract.collectiveContractId].collectiveContractId : "",
              candidate: view.externalImportCandidate.collectiveContractId,
              requiresStoreId: true
            });
            break;
          //jobName
          case "jobName":
          case "jn":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.job'),
              employee: contract != null ? contract.jobName : "",
              candidate: view.externalImportCandidate.jobName,
              requiresStoreId: true
            });
            break;
          //contractType
          case "contractType":
          case "ct":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.contractType'),
              employee: contract != null ? view.$t(`enum.contractType.${contract.contractType}`) : "",
              candidate: view.$t(`enum.contractType.${view.externalImportCandidate.contractType}`),
              requiresStoreId: true
            });
            break;
          //contractStart
          case "contractStart":
          case "cs":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.contractStart'),
              employee: contract != null ? this.formatDate(contract.from) : "",
              candidate: this.formatDate(view.externalImportCandidate.contractStart),
              requiresStoreId: true
            });
            break;
          //contractEnd
          case "contractEnd":
          case "ce":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.contractEnd'),
              employee: contract != null ? this.formatDate(contract.to) : "",
              candidate: this.formatDate(view.externalImportCandidate.contractEnd),
              requiresStoreId: true
            });
            break;
          //exitReason
          case "exitReason":
          case "er":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.exitReason'),
              employee: contract != null ? view.$t(`enum.exitReason.${contract.exitReason}`) : "",
              candidate: view.$t(`enum.exitReason.${view.externalImportCandidate.exitReason}`),
              requiresStoreId: true
            });
            break;
          //employeeCategory
          case "employeeCategory":
          case "ec":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.employeeCategory'),
              employee: contract != null ? view.$t(`enum.employeeCategory.${contract.employeeCategory}`) : "",
              candidate: view.$t(`enum.employeeCategory.${view.externalImportCandidate.employeeCategory}`),
              requiresStoreId: true
            });
            break;
          //employmentType
          case "employmentType":
          case "et":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.employmentType'),
              employee: contract != null ? view.$t(`enum.employmentType.${contract.employmentType}`) : "",
              candidate: view.$t(`enum.employmentType.${view.externalImportCandidate.employmentType}`),
              requiresStoreId: true
            });
            break;
          //weekTimeRegular
          case "weekTimeRegular":
          case "wtr":
            view.externalImportIssueFields.push({
              field: view.$t('employee.contract.weeklyHours'),
              employee: contract != null ? contract.weekTimeRegular / 60.0 : "",
              candidate: view.externalImportCandidate.weekTimeRegular / 60.0,
              requiresStoreId: true
            });
            break;
          //monthTimeRegular
          case "monthTimeRegular":
          case "mtr":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.monthlyHours'),
              employee: contract != null ? (Math.round((view.allowedContracts[contract.storeId][contract.collectiveContractId].monthTimeRegular / 60.0 + Number.EPSILON) * 100) / 100) : "",
              candidate: view.externalImportCandidate.monthTimeRegular ? (Math.round((view.externalImportCandidate.monthTimeRegular / 60.0 + Number.EPSILON) * 100) / 100) : "",
              requiresStoreId: true
            });
            break;
          //weekWorkDaysRegular
          case "weekWorkDaysRegular":
          case "wwdr":
            view.externalImportIssueFields.push({
              field: this.$t('employee.export.workdaysPerWeek'),
              employee: contract != null ? contract.weekWorkDaysRegular : "",
              candidate: view.externalImportCandidate.weekWorkDaysRegular,
              requiresStoreId: true
            });
            break;
          //vacationTime
          case "vacationTime":
          case "vt":
            view.externalImportIssueFields.push({
              field: view.$t('employee.import.vacationDays'),
              employee: contract != null ? contract.vacationTime / 60 / 24 : "",
              candidate: view.externalImportCandidate.vacationTime,
              requiresStoreId: true
            });
            break;
          default: break;
        }


      });

      this.$refs["modal-external-data-changed"].show();
    },
    closeExternalDataChangedModal() {
      this.$refs["modal-external-data-changed"].hide();
    },
    openExternalDataChangedMatchingModal() {
      this.$refs["modal-external-data-changed-matching"].show();
    },
    closeExternalDataChangedMatchingModal() {
      this.$refs["modal-external-data-changed-matching"].hide();
    },
    getLatestValidUntilDate(employeeId, documentType) {
      let view = this;
      let documents = view.employeeDocuments[employeeId];
      if (documents === undefined) return "";
      let filteredDocuments = documents.filter(doc => doc.documentType === documentType);
      if (filteredDocuments.length === 0) return "";
      let sortedDocuments = filteredDocuments.sort((a, b) => b.validUntil - a.validUntil);
      let docMoment = view.$helpers.getMomentFromStringUTC(sortedDocuments[0].validUntil);
      return docMoment.tz("Europe/Vienna").format("DD.MM.YYYY");
    },
  },
}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

.xColumn3 {
  width: 400px;
  text-align: left;
  float: left;
  margin-left: 25px;
  margin-right: 25px;
  overflow-y: auto;
  max-height: 800px;
}

.btn-ml {
  color: #fff;
  background-color: var(--ml);
  border-color: var(--ml);
}

tr:hover .btn-ml {
  color: #fff;
  background-color: var(--ml-alt);
  border-color: #fff;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.buttons {
  width: 100%;
  display: flex;
  justify-content: center;
}

.emp-core-data {
  display: flex;
  align-items: center;
  padding: 5px;
}

.emp-core-data > div {
  padding-right: 5px;
}

.label-pagination{
  display: inline;
  font-family: DistrictProBook;
  font-size: 14px;
  color: var(--contrast-4);
}


</style>
